import * as i0 from '@angular/core';
import { ChangeDetectorRef, ElementRef, NgZone, Component, ChangeDetectionStrategy, APP_INITIALIZER, NgModule } from '@angular/core';
import { __decorate, __metadata } from 'tslib';
import { fromEvent } from 'rxjs';
import { defineCustomElements } from '@sew/ui-components/loader';

/* eslint-disable */
/* tslint:disable */
const _c0 = ["*"];
const proxyInputs = (Cmp, inputs) => {
  const Prototype = Cmp.prototype;
  inputs.forEach(item => {
    Object.defineProperty(Prototype, item, {
      get() {
        return this.el[item];
      },
      set(val) {
        this.z.runOutsideAngular(() => this.el[item] = val);
      },
      /**
       * In the event that proxyInputs is called
       * multiple times re-defining these inputs
       * will cause an error to be thrown. As a result
       * we set configurable: true to indicate these
       * properties can be changed.
       */
      configurable: true
    });
  });
};
const proxyMethods = (Cmp, methods) => {
  const Prototype = Cmp.prototype;
  methods.forEach(methodName => {
    Prototype[methodName] = function () {
      const args = arguments;
      return this.z.runOutsideAngular(() => this.el[methodName].apply(this.el, args));
    };
  });
};
const proxyOutputs = (instance, el, events) => {
  events.forEach(eventName => instance[eventName] = fromEvent(el, eventName));
};
const defineCustomElement = (tagName, customElement) => {
  if (customElement !== undefined && typeof customElements !== 'undefined' && !customElements.get(tagName)) {
    customElements.define(tagName, customElement);
  }
};
// tslint:disable-next-line: only-arrow-functions
function ProxyCmp(opts) {
  const decorator = function (cls) {
    const {
      defineCustomElementFn,
      inputs,
      methods
    } = opts;
    if (defineCustomElementFn !== undefined) {
      defineCustomElementFn();
    }
    if (inputs) {
      proxyInputs(cls, inputs);
    }
    if (methods) {
      proxyMethods(cls, methods);
    }
    return cls;
  };
  return decorator;
}
let SewAccordion = /*#__PURE__*/(() => {
  let SewAccordion = class SewAccordion {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewAccordion_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewAccordion)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewAccordion,
      selectors: [["sew-accordion"]],
      inputs: {
        headline: "headline",
        limitHide: "limitHide",
        limitRows: "limitRows",
        limitShow: "limitShow",
        size: "size",
        ws: "ws"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewAccordion_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewAccordion = __decorate([ProxyCmp({
    inputs: ['headline', 'limitHide', 'limitRows', 'limitShow', 'size', 'ws']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewAccordion);
  return SewAccordion;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewAccordionItem = /*#__PURE__*/(() => {
  let SewAccordionItem = class SewAccordionItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['itemClicked']);
    }
    static ɵfac = function SewAccordionItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewAccordionItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewAccordionItem,
      selectors: [["sew-accordion-item"]],
      inputs: {
        disabled: "disabled",
        headline: "headline",
        icon: "icon",
        open: "open",
        restrictContentWidth: "restrictContentWidth",
        size: "size",
        ws: "ws"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewAccordionItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewAccordionItem = __decorate([ProxyCmp({
    inputs: ['disabled', 'headline', 'icon', 'open', 'restrictContentWidth', 'size', 'ws']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewAccordionItem);
  return SewAccordionItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewAdTeaser = /*#__PURE__*/(() => {
  let SewAdTeaser = class SewAdTeaser {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewAdTeaser_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewAdTeaser)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewAdTeaser,
      selectors: [["sew-ad-teaser"]],
      inputs: {
        headline: "headline",
        text: "text",
        vertical: "vertical"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewAdTeaser_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewAdTeaser = __decorate([ProxyCmp({
    inputs: ['headline', 'text', 'vertical']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewAdTeaser);
  return SewAdTeaser;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewApplication = /*#__PURE__*/(() => {
  let SewApplication = class SewApplication {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewApplication_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewApplication)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewApplication,
      selectors: [["sew-application"]],
      inputs: {
        panelFloating: "panelFloating",
        panelSize: "panelSize"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewApplication_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewApplication = __decorate([ProxyCmp({
    inputs: ['panelFloating', 'panelSize']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewApplication);
  return SewApplication;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewApplicationContent = /*#__PURE__*/(() => {
  let SewApplicationContent = class SewApplicationContent {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewApplicationContent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewApplicationContent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewApplicationContent,
      selectors: [["sew-application-content"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewApplicationContent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewApplicationContent = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewApplicationContent);
  return SewApplicationContent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewButton = /*#__PURE__*/(() => {
  let SewButton = class SewButton {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewButton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewButton,
      selectors: [["sew-button"]],
      inputs: {
        disabled: "disabled",
        hierarchy: "hierarchy",
        icon: "icon",
        isActive: "isActive",
        loading: "loading",
        monochrome: "monochrome",
        selected: "selected",
        showIconOnly: "showIconOnly",
        size: "size",
        suppressDensityMode: "suppressDensityMode"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewButton_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewButton = __decorate([ProxyCmp({
    inputs: ['disabled', 'hierarchy', 'icon', 'isActive', 'loading', 'monochrome', 'selected', 'showIconOnly', 'size', 'suppressDensityMode']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewButton);
  return SewButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewCapacityIndicator = /*#__PURE__*/(() => {
  let SewCapacityIndicator = class SewCapacityIndicator {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewCapacityIndicator_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewCapacityIndicator)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewCapacityIndicator,
      selectors: [["sew-capacity-indicator"]],
      inputs: {
        label: "label",
        monochrome: "monochrome",
        noIcons: "noIcons",
        threshold1: "threshold1",
        threshold2: "threshold2",
        value: "value"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewCapacityIndicator_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewCapacityIndicator = __decorate([ProxyCmp({
    inputs: ['label', 'monochrome', 'noIcons', 'threshold1', 'threshold2', 'value']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewCapacityIndicator);
  return SewCapacityIndicator;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewCards = /*#__PURE__*/(() => {
  let SewCards = class SewCards {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewCards_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewCards)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewCards,
      selectors: [["sew-cards"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewCards_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewCards = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewCards);
  return SewCards;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewCardsItem = /*#__PURE__*/(() => {
  let SewCardsItem = class SewCardsItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewCardsItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewCardsItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewCardsItem,
      selectors: [["sew-cards-item"]],
      inputs: {
        description: "description",
        headline: "headline",
        icon: "icon"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewCardsItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewCardsItem = __decorate([ProxyCmp({
    inputs: ['description', 'headline', 'icon']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewCardsItem);
  return SewCardsItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewCheckbox = /*#__PURE__*/(() => {
  let SewCheckbox = class SewCheckbox {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewCheckbox_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewCheckbox)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewCheckbox,
      selectors: [["sew-checkbox"]],
      inputs: {
        error: "error",
        status: "status",
        statusIcon: "statusIcon",
        ws: "ws"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewCheckbox_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewCheckbox = __decorate([ProxyCmp({
    inputs: ['error', 'status', 'statusIcon', 'ws']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewCheckbox);
  return SewCheckbox;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewCheckboxGroup = /*#__PURE__*/(() => {
  let SewCheckboxGroup = class SewCheckboxGroup {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewCheckboxGroup_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewCheckboxGroup)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewCheckboxGroup,
      selectors: [["sew-checkbox-group"]],
      inputs: {
        direction: "direction",
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewCheckboxGroup_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewCheckboxGroup = __decorate([ProxyCmp({
    inputs: ['direction', 'headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewCheckboxGroup);
  return SewCheckboxGroup;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewCmsSvgList = /*#__PURE__*/(() => {
  let SewCmsSvgList = class SewCmsSvgList {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewCmsSvgList_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewCmsSvgList)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewCmsSvgList,
      selectors: [["sew-cms-svg-list"]],
      inputs: {
        url: "url"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewCmsSvgList_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewCmsSvgList = __decorate([ProxyCmp({
    inputs: ['url']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewCmsSvgList);
  return SewCmsSvgList;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewCombobox = /*#__PURE__*/(() => {
  let SewCombobox = class SewCombobox {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['itemSelected', 'searchFieldInput', 'customFieldInput', 'componentFocusOut', 'menuHeightChanged']);
    }
    static ɵfac = function SewCombobox_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewCombobox)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewCombobox,
      selectors: [["sew-combobox"]],
      inputs: {
        alwaysFocusable: "alwaysFocusable",
        comboboxId: "comboboxId",
        customInput: "customInput",
        customInputLabel: "customInputLabel",
        customInputPlaceholder: "customInputPlaceholder",
        disabled: "disabled",
        error: "error",
        fullReset: "fullReset",
        highlight: "highlight",
        highlightedOptionValue: "highlightedOptionValue",
        limitMenuWidth: "limitMenuWidth",
        maxHeightInPixel: "maxHeightInPixel",
        noSearch: "noSearch",
        openOnFocus: "openOnFocus",
        optionsText: "optionsText",
        placeholder: "placeholder",
        readonly: "readonly",
        recommendedText: "recommendedText",
        selectAllText: "selectAllText",
        status: "status",
        statusIcon: "statusIcon",
        valid: "valid",
        ws: "ws"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewCombobox_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewCombobox = __decorate([ProxyCmp({
    inputs: ['alwaysFocusable', 'comboboxId', 'customInput', 'customInputLabel', 'customInputPlaceholder', 'disabled', 'error', 'fullReset', 'highlight', 'highlightedOptionValue', 'limitMenuWidth', 'maxHeightInPixel', 'noSearch', 'openOnFocus', 'optionsText', 'placeholder', 'readonly', 'recommendedText', 'selectAllText', 'status', 'statusIcon', 'valid', 'ws'],
    methods: ['reset']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewCombobox);
  return SewCombobox;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewDeliveryStatus = /*#__PURE__*/(() => {
  let SewDeliveryStatus = class SewDeliveryStatus {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewDeliveryStatus_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewDeliveryStatus)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewDeliveryStatus,
      selectors: [["sew-delivery-status"]],
      inputs: {
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewDeliveryStatus_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewDeliveryStatus = __decorate([ProxyCmp({
    inputs: ['type']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewDeliveryStatus);
  return SewDeliveryStatus;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewDialog = /*#__PURE__*/(() => {
  let SewDialog = class SewDialog {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['close']);
    }
    static ɵfac = function SewDialog_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewDialog)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewDialog,
      selectors: [["sew-dialog"]],
      inputs: {
        closeButton: "closeButton",
        headline: "headline",
        label: "label",
        open: "open",
        size: "size",
        status: "status",
        type: "type",
        ws: "ws"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewDialog_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewDialog = __decorate([ProxyCmp({
    inputs: ['closeButton', 'headline', 'label', 'open', 'size', 'status', 'type', 'ws']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewDialog);
  return SewDialog;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewDropdown = /*#__PURE__*/(() => {
  let SewDropdown = class SewDropdown {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['itemSelectedEvent', 'dropdownClose']);
    }
    static ɵfac = function SewDropdown_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewDropdown)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewDropdown,
      selectors: [["sew-dropdown"]],
      inputs: {
        disabledText: "disabledText",
        dropdownAriaLabel: "dropdownAriaLabel",
        dropdownId: "dropdownId",
        error: "error",
        errorText: "errorText",
        fullReset: "fullReset",
        helpText: "helpText",
        highlightedOptionValue: "highlightedOptionValue",
        isInactive: "isInactive",
        itemsAsJson: "itemsAsJson",
        maxHeightInPixel: "maxHeightInPixel",
        openOnFocus: "openOnFocus",
        placeholder: "placeholder",
        recommendedText: "recommendedText",
        selectedValue: "selectedValue",
        showSearchField: "showSearchField",
        ws: "ws"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewDropdown_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewDropdown = __decorate([ProxyCmp({
    inputs: ['disabledText', 'dropdownAriaLabel', 'dropdownId', 'error', 'errorText', 'fullReset', 'helpText', 'highlightedOptionValue', 'isInactive', 'itemsAsJson', 'maxHeightInPixel', 'openOnFocus', 'placeholder', 'recommendedText', 'selectedValue', 'showSearchField', 'ws'],
    methods: ['resetSelection']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewDropdown);
  return SewDropdown;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewFileUpload = /*#__PURE__*/(() => {
  let SewFileUpload = class SewFileUpload {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['fileschange', 'fileerror']);
    }
    static ɵfac = function SewFileUpload_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewFileUpload)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewFileUpload,
      selectors: [["sew-file-upload"]],
      inputs: {
        allowedMimeTypes: "allowedMimeTypes",
        backendFileControl: "backendFileControl",
        backendFiles: "backendFiles",
        button: "button",
        dragAndDropDisabled: "dragAndDropDisabled",
        error: "error",
        errorText: "errorText",
        footnote: "footnote",
        manual: "manual",
        maxFileSize: "maxFileSize",
        maxFiles: "maxFiles",
        supported: "supported",
        ws: "ws"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewFileUpload_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewFileUpload = __decorate([ProxyCmp({
    inputs: ['allowedMimeTypes', 'backendFileControl', 'backendFiles', 'button', 'dragAndDropDisabled', 'error', 'errorText', 'footnote', 'manual', 'maxFileSize', 'maxFiles', 'supported', 'ws'],
    methods: ['reset']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewFileUpload);
  return SewFileUpload;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewForm = /*#__PURE__*/(() => {
  let SewForm = class SewForm {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewForm_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewForm)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewForm,
      selectors: [["sew-form"]],
      inputs: {
        noGrid: "noGrid",
        noMargin: "noMargin",
        ws: "ws"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewForm_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewForm = __decorate([ProxyCmp({
    inputs: ['noGrid', 'noMargin', 'ws']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewForm);
  return SewForm;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewFormRow = /*#__PURE__*/(() => {
  let SewFormRow = class SewFormRow {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewFormRow_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewFormRow)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewFormRow,
      selectors: [["sew-form-row"]],
      inputs: {
        earlyWrap: "earlyWrap",
        split: "split"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewFormRow_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewFormRow = __decorate([ProxyCmp({
    inputs: ['earlyWrap', 'split']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewFormRow);
  return SewFormRow;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewFormRowItem = /*#__PURE__*/(() => {
  let SewFormRowItem = class SewFormRowItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewFormRowItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewFormRowItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewFormRowItem,
      selectors: [["sew-form-row-item"]],
      inputs: {
        bottom: "bottom",
        group: "group",
        right: "right"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewFormRowItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewFormRowItem = __decorate([ProxyCmp({
    inputs: ['bottom', 'group', 'right']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewFormRowItem);
  return SewFormRowItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewFourColumnGrid = /*#__PURE__*/(() => {
  let SewFourColumnGrid = class SewFourColumnGrid {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewFourColumnGrid_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewFourColumnGrid)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewFourColumnGrid,
      selectors: [["sew-four-column-grid"]],
      inputs: {
        disableDefaultMargin: "disableDefaultMargin"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewFourColumnGrid_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewFourColumnGrid = __decorate([ProxyCmp({
    inputs: ['disableDefaultMargin']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewFourColumnGrid);
  return SewFourColumnGrid;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewHeader = /*#__PURE__*/(() => {
  let SewHeader = class SewHeader {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewHeader_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewHeader)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewHeader,
      selectors: [["sew-header"]],
      inputs: {
        panelSize: "panelSize"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewHeader_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewHeader = __decorate([ProxyCmp({
    inputs: ['panelSize']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewHeader);
  return SewHeader;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewHeadline = /*#__PURE__*/(() => {
  let SewHeadline = class SewHeadline {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewHeadline_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewHeadline)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewHeadline,
      selectors: [["sew-headline"]],
      inputs: {
        level: "level",
        noMargin: "noMargin",
        ws: "ws"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewHeadline_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewHeadline = __decorate([ProxyCmp({
    inputs: ['level', 'noMargin', 'ws']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewHeadline);
  return SewHeadline;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewIcon = /*#__PURE__*/(() => {
  let SewIcon = class SewIcon {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['iconLoaded']);
    }
    static ɵfac = function SewIcon_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewIcon)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewIcon,
      selectors: [["sew-icon"]],
      inputs: {
        fluid: "fluid",
        height: "height",
        icon: "icon",
        size: "size",
        width: "width"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewIcon_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewIcon = __decorate([ProxyCmp({
    inputs: ['fluid', 'height', 'icon', 'size', 'width']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewIcon);
  return SewIcon;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewImageViewer = /*#__PURE__*/(() => {
  let SewImageViewer = class SewImageViewer {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewImageViewer_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewImageViewer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewImageViewer,
      selectors: [["sew-image-viewer"]],
      inputs: {
        aspectRatio: "aspectRatio",
        downloadLabel: "downloadLabel",
        headline: "headline",
        maxZoom: "maxZoom",
        minZoom: "minZoom",
        openInNewTabLabel: "openInNewTabLabel"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewImageViewer_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewImageViewer = __decorate([ProxyCmp({
    inputs: ['aspectRatio', 'downloadLabel', 'headline', 'maxZoom', 'minZoom', 'openInNewTabLabel'],
    methods: ['setActiveElement']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewImageViewer);
  return SewImageViewer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewInput = /*#__PURE__*/(() => {
  let SewInput = class SewInput {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['qrCodeFound', 'changeDate']);
    }
    static ɵfac = function SewInput_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewInput)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewInput,
      selectors: [["sew-input"]],
      inputs: {
        date: "date",
        datepicker: "datepicker",
        datepickerConfig: "datepickerConfig",
        error: "error",
        highlight: "highlight",
        qrcodescanner: "qrcodescanner",
        resizable: "resizable",
        status: "status",
        statusIcon: "statusIcon",
        unit: "unit",
        valid: "valid",
        ws: "ws"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewInput_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewInput = __decorate([ProxyCmp({
    inputs: ['date', 'datepicker', 'datepickerConfig', 'error', 'highlight', 'qrcodescanner', 'resizable', 'status', 'statusIcon', 'unit', 'valid', 'ws']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewInput);
  return SewInput;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewLink = /*#__PURE__*/(() => {
  let SewLink = class SewLink {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewLink_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewLink)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewLink,
      selectors: [["sew-link"]],
      inputs: {
        icon: "icon"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewLink_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewLink = __decorate([ProxyCmp({
    inputs: ['icon']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewLink);
  return SewLink;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewLoader = /*#__PURE__*/(() => {
  let SewLoader = class SewLoader {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewLoader_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewLoader)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewLoader,
      selectors: [["sew-loader"]],
      inputs: {
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewLoader_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewLoader = __decorate([ProxyCmp({
    inputs: ['text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewLoader);
  return SewLoader;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewLoaderMini = /*#__PURE__*/(() => {
  let SewLoaderMini = class SewLoaderMini {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewLoaderMini_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewLoaderMini)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewLoaderMini,
      selectors: [["sew-loader-mini"]],
      inputs: {
        width: "width"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewLoaderMini_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewLoaderMini = __decorate([ProxyCmp({
    inputs: ['width']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewLoaderMini);
  return SewLoaderMini;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewMap = /*#__PURE__*/(() => {
  let SewMap = class SewMap {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['zoomChanged', 'idle', 'markerClicked']);
    }
    static ɵfac = function SewMap_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewMap)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewMap,
      selectors: [["sew-map"]],
      inputs: {
        apiKey: "apiKey",
        configStr: "configStr",
        consentButtonText: "consentButtonText",
        disableConsentCheck: "disableConsentCheck",
        labels: "labels",
        localizationStr: "localizationStr",
        mapStateStr: "mapStateStr",
        markersStr: "markersStr"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewMap_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewMap = __decorate([ProxyCmp({
    inputs: ['apiKey', 'configStr', 'consentButtonText', 'disableConsentCheck', 'labels', 'localizationStr', 'mapStateStr', 'markersStr'],
    methods: ['displayMapState', 'displayMarkers', 'displayMarkersAnimated', 'removeAllMarkers', 'openMarkerInfoWindow']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewMap);
  return SewMap;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewMarkdown = /*#__PURE__*/(() => {
  let SewMarkdown = class SewMarkdown {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewMarkdown_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewMarkdown)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewMarkdown,
      selectors: [["sew-markdown"]],
      inputs: {
        marginBottom: "marginBottom",
        marginTop: "marginTop",
        markdown: "markdown",
        ws: "ws"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewMarkdown_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewMarkdown = __decorate([ProxyCmp({
    inputs: ['marginBottom', 'marginTop', 'markdown', 'ws']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewMarkdown);
  return SewMarkdown;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewMasterDetail = /*#__PURE__*/(() => {
  let SewMasterDetail = class SewMasterDetail {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewMasterDetail_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewMasterDetail)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewMasterDetail,
      selectors: [["sew-master-detail"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewMasterDetail_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewMasterDetail = __decorate([ProxyCmp({
    methods: ['openPanel', 'closePanel']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewMasterDetail);
  return SewMasterDetail;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewMasterDetailPanel = /*#__PURE__*/(() => {
  let SewMasterDetailPanel = class SewMasterDetailPanel {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewMasterDetailPanel_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewMasterDetailPanel)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewMasterDetailPanel,
      selectors: [["sew-master-detail-panel"]],
      inputs: {
        headline: "headline",
        open: "open"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewMasterDetailPanel_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewMasterDetailPanel = __decorate([ProxyCmp({
    inputs: ['headline', 'open']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewMasterDetailPanel);
  return SewMasterDetailPanel;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewMenu = /*#__PURE__*/(() => {
  let SewMenu = class SewMenu {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewMenu_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewMenu)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewMenu,
      selectors: [["sew-menu"]],
      inputs: {
        maxHeightInPixel: "maxHeightInPixel",
        open: "open"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewMenu_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewMenu = __decorate([ProxyCmp({
    inputs: ['maxHeightInPixel', 'open']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewMenu);
  return SewMenu;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewMenu2 = /*#__PURE__*/(() => {
  let SewMenu2 = class SewMenu2 {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewMenu2_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewMenu2)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewMenu2,
      selectors: [["sew-menu-2"]],
      inputs: {
        menuFor: "menuFor",
        open: "open",
        openAside: "openAside"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewMenu2_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewMenu2 = __decorate([ProxyCmp({
    inputs: ['menuFor', 'open', 'openAside']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewMenu2);
  return SewMenu2;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewMenuItem = /*#__PURE__*/(() => {
  let SewMenuItem = class SewMenuItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewMenuItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewMenuItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewMenuItem,
      selectors: [["sew-menu-item"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewMenuItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewMenuItem = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewMenuItem);
  return SewMenuItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewMenuItem2 = /*#__PURE__*/(() => {
  let SewMenuItem2 = class SewMenuItem2 {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewMenuItem2_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewMenuItem2)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewMenuItem2,
      selectors: [["sew-menu-item-2"]],
      inputs: {
        active: "active",
        disabled: "disabled"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewMenuItem2_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewMenuItem2 = __decorate([ProxyCmp({
    inputs: ['active', 'disabled']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewMenuItem2);
  return SewMenuItem2;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewMultiselect = /*#__PURE__*/(() => {
  let SewMultiselect = class SewMultiselect {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['dropdownClose']);
    }
    static ɵfac = function SewMultiselect_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewMultiselect)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewMultiselect,
      selectors: [["sew-multiselect"]],
      inputs: {
        disabled: "disabled",
        disabledText: "disabledText",
        error: "error",
        errorText: "errorText",
        helpText: "helpText",
        label: "label",
        maxHeightInPixel: "maxHeightInPixel",
        multiselectId: "multiselectId",
        openOnFocus: "openOnFocus",
        optionsTextPlural: "optionsTextPlural",
        optionsTextSingular: "optionsTextSingular",
        placeholder: "placeholder"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewMultiselect_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewMultiselect = __decorate([ProxyCmp({
    inputs: ['disabled', 'disabledText', 'error', 'errorText', 'helpText', 'label', 'maxHeightInPixel', 'multiselectId', 'openOnFocus', 'optionsTextPlural', 'optionsTextSingular', 'placeholder']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewMultiselect);
  return SewMultiselect;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewNotification = /*#__PURE__*/(() => {
  let SewNotification = class SewNotification {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['removeNotification', 'closeAnimation']);
    }
    static ɵfac = function SewNotification_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewNotification)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewNotification,
      selectors: [["sew-notification"]],
      inputs: {
        headline: "headline",
        notificationId: "notificationId",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewNotification_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewNotification = __decorate([ProxyCmp({
    inputs: ['headline', 'notificationId', 'type'],
    methods: ['close']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewNotification);
  return SewNotification;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewNotificationStack = /*#__PURE__*/(() => {
  let SewNotificationStack = class SewNotificationStack {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewNotificationStack_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewNotificationStack)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewNotificationStack,
      selectors: [["sew-notification-stack"]],
      inputs: {
        collapsedLabel: "collapsedLabel",
        direction: "direction",
        expandedLabel: "expandedLabel"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewNotificationStack_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewNotificationStack = __decorate([ProxyCmp({
    inputs: ['collapsedLabel', 'direction', 'expandedLabel'],
    methods: ['clearAllNotifications', 'clearNotificationById']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewNotificationStack);
  return SewNotificationStack;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewObserve = /*#__PURE__*/(() => {
  let SewObserve = class SewObserve {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewObserve_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewObserve)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewObserve,
      selectors: [["sew-observe"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewObserve_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewObserve = __decorate([ProxyCmp({
    methods: ['gsapBootstrap']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewObserve);
  return SewObserve;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewPicture = /*#__PURE__*/(() => {
  let SewPicture = class SewPicture {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['sewPictureLoaded']);
    }
    static ɵfac = function SewPicture_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewPicture)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewPicture,
      selectors: [["sew-picture"]],
      inputs: {
        alt: "alt",
        caption: "caption",
        height: "height",
        imgTitle: "imgTitle",
        objectFit: "objectFit",
        objectFitContain: "objectFitContain",
        sewPictureComplete: "sewPictureComplete",
        shiftCaptionRight: "shiftCaptionRight",
        shiftCaptionRightMq3: "shiftCaptionRightMq3",
        showImage: "showImage",
        src: "src",
        width: "width"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewPicture_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewPicture = __decorate([ProxyCmp({
    inputs: ['alt', 'caption', 'height', 'imgTitle', 'objectFit', 'objectFitContain', 'sewPictureComplete', 'shiftCaptionRight', 'shiftCaptionRightMq3', 'showImage', 'src', 'width'],
    methods: ['reloadImage']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewPicture);
  return SewPicture;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewRadio = /*#__PURE__*/(() => {
  let SewRadio = class SewRadio {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewRadio_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewRadio)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewRadio,
      selectors: [["sew-radio"]],
      inputs: {
        error: "error",
        ws: "ws"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewRadio_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewRadio = __decorate([ProxyCmp({
    inputs: ['error', 'ws'],
    methods: ['updateCheckedState']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewRadio);
  return SewRadio;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewRadioGroup = /*#__PURE__*/(() => {
  let SewRadioGroup = class SewRadioGroup {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewRadioGroup_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewRadioGroup)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewRadioGroup,
      selectors: [["sew-radio-group"]],
      inputs: {
        direction: "direction",
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewRadioGroup_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewRadioGroup = __decorate([ProxyCmp({
    inputs: ['direction', 'headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewRadioGroup);
  return SewRadioGroup;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewRangeSlider = /*#__PURE__*/(() => {
  let SewRangeSlider = class SewRangeSlider {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewRangeSlider_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewRangeSlider)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewRangeSlider,
      selectors: [["sew-range-slider"]],
      inputs: {
        markers: "markers",
        valueIndicator: "valueIndicator"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewRangeSlider_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewRangeSlider = __decorate([ProxyCmp({
    inputs: ['markers', 'valueIndicator']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewRangeSlider);
  return SewRangeSlider;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewRichtext = /*#__PURE__*/(() => {
  let SewRichtext = class SewRichtext {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewRichtext_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewRichtext)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewRichtext,
      selectors: [["sew-richtext"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewRichtext_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewRichtext = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewRichtext);
  return SewRichtext;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewRichtextEditor = /*#__PURE__*/(() => {
  let SewRichtextEditor = class SewRichtextEditor {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['richtextChange']);
    }
    static ɵfac = function SewRichtextEditor_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewRichtextEditor)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewRichtextEditor,
      selectors: [["sew-richtext-editor"]],
      inputs: {
        disabled: "disabled",
        error: "error",
        label: "label",
        text: "text",
        users: "users"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewRichtextEditor_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewRichtextEditor = __decorate([ProxyCmp({
    inputs: ['disabled', 'error', 'label', 'text', 'users'],
    methods: ['getContents']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewRichtextEditor);
  return SewRichtextEditor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewSearchField = /*#__PURE__*/(() => {
  let SewSearchField = class SewSearchField {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['itemClicked', 'qrCodeFound', 'inputReset']);
    }
    static ɵfac = function SewSearchField_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewSearchField)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewSearchField,
      selectors: [["sew-search-field"]],
      inputs: {
        error: "error",
        inline: "inline",
        items: "items",
        noFilter: "noFilter",
        noSearchIcon: "noSearchIcon",
        qrcodescanner: "qrcodescanner",
        size: "size",
        ws: "ws"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewSearchField_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewSearchField = __decorate([ProxyCmp({
    inputs: ['error', 'inline', 'items', 'noFilter', 'noSearchIcon', 'qrcodescanner', 'size', 'ws']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewSearchField);
  return SewSearchField;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewSearchFieldGoogleApi = /*#__PURE__*/(() => {
  let SewSearchFieldGoogleApi = class SewSearchFieldGoogleApi {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['locationChange']);
    }
    static ɵfac = function SewSearchFieldGoogleApi_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewSearchFieldGoogleApi)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewSearchFieldGoogleApi,
      selectors: [["sew-search-field-google-api"]],
      inputs: {
        apiBaseUrl: "apiBaseUrl",
        apiKey: "apiKey",
        currentPositionLabel: "currentPositionLabel",
        disableConsentCheck: "disableConsentCheck",
        enableCurrentPosition: "enableCurrentPosition",
        externalZipcodeInputName: "externalZipcodeInputName",
        externalZipcodeSearch: "externalZipcodeSearch",
        helpText: "helpText",
        initialValue: "initialValue",
        isFixed: "isFixed",
        localization: "localization",
        placeholder: "placeholder",
        size: "size",
        small: "small"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewSearchFieldGoogleApi_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewSearchFieldGoogleApi = __decorate([ProxyCmp({
    inputs: ['apiBaseUrl', 'apiKey', 'currentPositionLabel', 'disableConsentCheck', 'enableCurrentPosition', 'externalZipcodeInputName', 'externalZipcodeSearch', 'helpText', 'initialValue', 'isFixed', 'localization', 'placeholder', 'size', 'small']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewSearchFieldGoogleApi);
  return SewSearchFieldGoogleApi;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewSidePanel = /*#__PURE__*/(() => {
  let SewSidePanel = class SewSidePanel {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['sidePanelClose']);
    }
    static ɵfac = function SewSidePanel_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewSidePanel)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewSidePanel,
      selectors: [["sew-side-panel"]],
      inputs: {
        expandable: "expandable",
        open: "open"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewSidePanel_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewSidePanel = __decorate([ProxyCmp({
    inputs: ['expandable', 'open'],
    methods: ['startAnimation', 'openPanel']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewSidePanel);
  return SewSidePanel;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewSidePanelItem = /*#__PURE__*/(() => {
  let SewSidePanelItem = class SewSidePanelItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['iconChange']);
    }
    static ɵfac = function SewSidePanelItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewSidePanelItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewSidePanelItem,
      selectors: [["sew-side-panel-item"]],
      inputs: {
        active: "active",
        animatedText: "animatedText",
        animationDelay: "animationDelay",
        animationDuration: "animationDuration",
        enableInitialAnimation: "enableInitialAnimation",
        headline: "headline",
        icon: "icon",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewSidePanelItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewSidePanelItem = __decorate([ProxyCmp({
    inputs: ['active', 'animatedText', 'animationDelay', 'animationDuration', 'enableInitialAnimation', 'headline', 'icon', 'type']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewSidePanelItem);
  return SewSidePanelItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewSingleCombobox = /*#__PURE__*/(() => {
  let SewSingleCombobox = class SewSingleCombobox {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['itemSelected']);
    }
    static ɵfac = function SewSingleCombobox_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewSingleCombobox)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewSingleCombobox,
      selectors: [["sew-single-combobox"]],
      inputs: {
        comboboxId: "comboboxId",
        customInput: "customInput",
        disabled: "disabled",
        error: "error",
        fullReset: "fullReset",
        highlightedOptionValue: "highlightedOptionValue",
        openOnFocus: "openOnFocus",
        placeholder: "placeholder",
        recommendedText: "recommendedText"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewSingleCombobox_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewSingleCombobox = __decorate([ProxyCmp({
    inputs: ['comboboxId', 'customInput', 'disabled', 'error', 'fullReset', 'highlightedOptionValue', 'openOnFocus', 'placeholder', 'recommendedText']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewSingleCombobox);
  return SewSingleCombobox;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewSkeleton = /*#__PURE__*/(() => {
  let SewSkeleton = class SewSkeleton {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewSkeleton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewSkeleton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewSkeleton,
      selectors: [["sew-skeleton"]],
      inputs: {
        height: "height",
        width: "width"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewSkeleton_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewSkeleton = __decorate([ProxyCmp({
    inputs: ['height', 'width']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewSkeleton);
  return SewSkeleton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewSlider = /*#__PURE__*/(() => {
  let SewSlider = class SewSlider {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewSlider_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewSlider)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewSlider,
      selectors: [["sew-slider"]],
      inputs: {
        stepNumber: "stepNumber",
        ws: "ws"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewSlider_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewSlider = __decorate([ProxyCmp({
    inputs: ['stepNumber', 'ws']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewSlider);
  return SewSlider;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewSplashScreen = /*#__PURE__*/(() => {
  let SewSplashScreen = class SewSplashScreen {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewSplashScreen_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewSplashScreen)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewSplashScreen,
      selectors: [["sew-splash-screen"]],
      inputs: {
        applicationName: "applicationName",
        applicationVersion: "applicationVersion",
        brandName: "brandName",
        caasBaseUrl: "caasBaseUrl",
        countryCode: "countryCode",
        language: "language",
        loading: "loading"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewSplashScreen_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewSplashScreen = __decorate([ProxyCmp({
    inputs: ['applicationName', 'applicationVersion', 'brandName', 'caasBaseUrl', 'countryCode', 'language', 'loading']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewSplashScreen);
  return SewSplashScreen;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewSwitch = /*#__PURE__*/(() => {
  let SewSwitch = class SewSwitch {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewSwitch_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewSwitch)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewSwitch,
      selectors: [["sew-switch"]],
      inputs: {
        hmi: "hmi",
        ws: "ws"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewSwitch_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewSwitch = __decorate([ProxyCmp({
    inputs: ['hmi', 'ws']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewSwitch);
  return SewSwitch;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewSwitchGroup = /*#__PURE__*/(() => {
  let SewSwitchGroup = class SewSwitchGroup {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewSwitchGroup_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewSwitchGroup)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewSwitchGroup,
      selectors: [["sew-switch-group"]],
      inputs: {
        direction: "direction",
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewSwitchGroup_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewSwitchGroup = __decorate([ProxyCmp({
    inputs: ['direction', 'headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewSwitchGroup);
  return SewSwitchGroup;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewTabBar = /*#__PURE__*/(() => {
  let SewTabBar = class SewTabBar {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewTabBar_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewTabBar)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewTabBar,
      selectors: [["sew-tab-bar"]],
      inputs: {
        hierarchy: "hierarchy"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewTabBar_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewTabBar = __decorate([ProxyCmp({
    inputs: ['hierarchy']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewTabBar);
  return SewTabBar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewTabBarItem = /*#__PURE__*/(() => {
  let SewTabBarItem = class SewTabBarItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['itemHasRendered']);
    }
    static ɵfac = function SewTabBarItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewTabBarItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewTabBarItem,
      selectors: [["sew-tab-bar-item"]],
      inputs: {
        disabled: "disabled",
        icon: "icon",
        name: "name",
        selected: "selected"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewTabBarItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewTabBarItem = __decorate([ProxyCmp({
    inputs: ['disabled', 'icon', 'name', 'selected']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewTabBarItem);
  return SewTabBarItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewTable = /*#__PURE__*/(() => {
  let SewTable = class SewTable {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['activeRowChange']);
    }
    static ɵfac = function SewTable_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewTable)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewTable,
      selectors: [["sew-table"]],
      inputs: {
        initialActiveRow: "initialActiveRow",
        size: "size",
        stickyHeader: "stickyHeader"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewTable_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewTable = __decorate([ProxyCmp({
    inputs: ['initialActiveRow', 'size', 'stickyHeader'],
    methods: ['scrollToActiveRow']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewTable);
  return SewTable;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewTableHeader = /*#__PURE__*/(() => {
  let SewTableHeader = class SewTableHeader {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewTableHeader_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewTableHeader)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewTableHeader,
      selectors: [["sew-table-header"]],
      inputs: {
        filterable: "filterable",
        name: "name",
        sortable: "sortable"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewTableHeader_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewTableHeader = __decorate([ProxyCmp({
    inputs: ['filterable', 'name', 'sortable']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewTableHeader);
  return SewTableHeader;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewTableHeaderFilter = /*#__PURE__*/(() => {
  let SewTableHeaderFilter = class SewTableHeaderFilter {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['sort', 'filterChange']);
    }
    static ɵfac = function SewTableHeaderFilter_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewTableHeaderFilter)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewTableHeaderFilter,
      selectors: [["sew-table-header-filter"]],
      inputs: {
        dirty: "dirty",
        ellipsis: "ellipsis",
        filterLabel: "filterLabel",
        hasReset: "hasReset",
        hideSortIconOnClosedState: "hideSortIconOnClosedState",
        label: "label",
        maxHeightInPixel: "maxHeightInPixel",
        optionText: "optionText",
        selectAllText: "selectAllText",
        size: "size",
        sortAscending: "sortAscending",
        sortDefault: "sortDefault",
        sortDescending: "sortDescending",
        sortOrder: "sortOrder"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewTableHeaderFilter_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewTableHeaderFilter = __decorate([ProxyCmp({
    inputs: ['dirty', 'ellipsis', 'filterLabel', 'hasReset', 'hideSortIconOnClosedState', 'label', 'maxHeightInPixel', 'optionText', 'selectAllText', 'size', 'sortAscending', 'sortDefault', 'sortDescending', 'sortOrder'],
    methods: ['resetValue', 'setValue', 'positionMenu']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewTableHeaderFilter);
  return SewTableHeaderFilter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewTableHeaderSort = /*#__PURE__*/(() => {
  let SewTableHeaderSort = class SewTableHeaderSort {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['sort']);
    }
    static ɵfac = function SewTableHeaderSort_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewTableHeaderSort)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewTableHeaderSort,
      selectors: [["sew-table-header-sort"]],
      inputs: {
        ellipsis: "ellipsis",
        label: "label",
        size: "size",
        sortAscending: "sortAscending",
        sortDefault: "sortDefault",
        sortDescending: "sortDescending",
        sortOrder: "sortOrder"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewTableHeaderSort_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewTableHeaderSort = __decorate([ProxyCmp({
    inputs: ['ellipsis', 'label', 'size', 'sortAscending', 'sortDefault', 'sortDescending', 'sortOrder']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewTableHeaderSort);
  return SewTableHeaderSort;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewTableInput = /*#__PURE__*/(() => {
  let SewTableInput = class SewTableInput {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewTableInput_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewTableInput)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewTableInput,
      selectors: [["sew-table-input"]],
      inputs: {
        error: "error",
        size: "size",
        unit: "unit"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewTableInput_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewTableInput = __decorate([ProxyCmp({
    inputs: ['error', 'size', 'unit']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewTableInput);
  return SewTableInput;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewTag = /*#__PURE__*/(() => {
  let SewTag = class SewTag {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['close']);
    }
    static ɵfac = function SewTag_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewTag)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewTag,
      selectors: [["sew-tag"]],
      inputs: {
        icon: "icon",
        removable: "removable",
        size: "size",
        suppressDensityMode: "suppressDensityMode",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewTag_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewTag = __decorate([ProxyCmp({
    inputs: ['icon', 'removable', 'size', 'suppressDensityMode', 'type']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewTag);
  return SewTag;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewTitleEditable = /*#__PURE__*/(() => {
  let SewTitleEditable = class SewTitleEditable {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewTitleEditable_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewTitleEditable)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewTitleEditable,
      selectors: [["sew-title-editable"]],
      inputs: {
        hoverText: "hoverText",
        savedValue: "savedValue",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewTitleEditable_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewTitleEditable = __decorate([ProxyCmp({
    inputs: ['hoverText', 'savedValue', 'type']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewTitleEditable);
  return SewTitleEditable;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewToolbar = /*#__PURE__*/(() => {
  let SewToolbar = class SewToolbar {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewToolbar_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewToolbar)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewToolbar,
      selectors: [["sew-toolbar"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewToolbar_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewToolbar = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewToolbar);
  return SewToolbar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewTooltip = /*#__PURE__*/(() => {
  let SewTooltip = class SewTooltip {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewTooltip_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewTooltip)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewTooltip,
      selectors: [["sew-tooltip"]],
      inputs: {
        autoWidth: "autoWidth",
        direction: "direction"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewTooltip_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewTooltip = __decorate([ProxyCmp({
    inputs: ['autoWidth', 'direction']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewTooltip);
  return SewTooltip;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewTypography = /*#__PURE__*/(() => {
  let SewTypography = class SewTypography {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewTypography_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewTypography)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewTypography,
      selectors: [["sew-typography"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewTypography_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewTypography = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewTypography);
  return SewTypography;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewVerticalNavigation = /*#__PURE__*/(() => {
  let SewVerticalNavigation = class SewVerticalNavigation {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewVerticalNavigation_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewVerticalNavigation)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewVerticalNavigation,
      selectors: [["sew-vertical-navigation"]],
      inputs: {
        closeLabel: "closeLabel",
        expanded: "expanded"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewVerticalNavigation_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewVerticalNavigation = __decorate([ProxyCmp({
    inputs: ['closeLabel', 'expanded'],
    methods: ['expandNavigation']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewVerticalNavigation);
  return SewVerticalNavigation;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewVerticalNavigationItem = /*#__PURE__*/(() => {
  let SewVerticalNavigationItem = class SewVerticalNavigationItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['navItemClicked']);
    }
    static ɵfac = function SewVerticalNavigationItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewVerticalNavigationItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewVerticalNavigationItem,
      selectors: [["sew-vertical-navigation-item"]],
      inputs: {
        disabled: "disabled",
        error: "error",
        icon: "icon",
        label: "label",
        selected: "selected",
        valid: "valid"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewVerticalNavigationItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewVerticalNavigationItem = __decorate([ProxyCmp({
    inputs: ['disabled', 'error', 'icon', 'label', 'selected', 'valid']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewVerticalNavigationItem);
  return SewVerticalNavigationItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewVideo = /*#__PURE__*/(() => {
  let SewVideo = class SewVideo {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['videoEnded', 'videoPlaying', 'videoPaused', 'playerReady', 'youtubeapiready', 'consentSet']);
    }
    static ɵfac = function SewVideo_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewVideo)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewVideo,
      selectors: [["sew-video"]],
      inputs: {
        allowFullScreen: "allowFullScreen",
        aspectRatio: "aspectRatio",
        autoplay: "autoplay",
        caption: "caption",
        consentButtonText: "consentButtonText",
        controls: "controls",
        disableConsentCheck: "disableConsentCheck",
        disablekb: "disablekb",
        fs: "fs",
        height: "height",
        hideCaption: "hideCaption",
        isReady: "isReady",
        loop: "loop",
        modestbranding: "modestbranding",
        mute: "mute",
        playsinline: "playsinline",
        preview: "preview",
        shiftCaptionRight: "shiftCaptionRight",
        showinfo: "showinfo",
        src: "src",
        videoTitle: "videoTitle",
        width: "width"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewVideo_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewVideo = __decorate([ProxyCmp({
    inputs: ['allowFullScreen', 'aspectRatio', 'autoplay', 'caption', 'consentButtonText', 'controls', 'disableConsentCheck', 'disablekb', 'fs', 'height', 'hideCaption', 'isReady', 'loop', 'modestbranding', 'mute', 'playsinline', 'preview', 'shiftCaptionRight', 'showinfo', 'src', 'videoTitle', 'width'],
    methods: ['startVideo', 'stopVideo', 'pauseVideo', 'resetVideo']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewVideo);
  return SewVideo;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWizard = /*#__PURE__*/(() => {
  let SewWizard = class SewWizard {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWizard_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWizard)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWizard,
      selectors: [["sew-wizard"]],
      inputs: {
        hierarchy: "hierarchy",
        interactive: "interactive"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWizard_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWizard = __decorate([ProxyCmp({
    inputs: ['hierarchy', 'interactive'],
    methods: ['setActiveStep', 'setCompletedStep']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWizard);
  return SewWizard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWizardItem = /*#__PURE__*/(() => {
  let SewWizardItem = class SewWizardItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['itemsChanged']);
    }
    static ɵfac = function SewWizardItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWizardItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWizardItem,
      selectors: [["sew-wizard-item"]],
      inputs: {
        active: "active",
        completed: "completed",
        disabled: "disabled",
        stepIndex: "stepIndex"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWizardItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWizardItem = __decorate([ProxyCmp({
    inputs: ['active', 'completed', 'disabled', 'stepIndex']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWizardItem);
  return SewWizardItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsAccordionHorizontal = /*#__PURE__*/(() => {
  let SewWsAccordionHorizontal = class SewWsAccordionHorizontal {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsAccordionHorizontal_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsAccordionHorizontal)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsAccordionHorizontal,
      selectors: [["sew-ws-accordion-horizontal"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsAccordionHorizontal_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsAccordionHorizontal = __decorate([ProxyCmp({
    inputs: ['headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsAccordionHorizontal);
  return SewWsAccordionHorizontal;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsAccordionHorizontalItem = /*#__PURE__*/(() => {
  let SewWsAccordionHorizontalItem = class SewWsAccordionHorizontalItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['itemOpened']);
    }
    static ɵfac = function SewWsAccordionHorizontalItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsAccordionHorizontalItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsAccordionHorizontalItem,
      selectors: [["sew-ws-accordion-horizontal-item"]],
      inputs: {
        headline: "headline",
        icon: "icon",
        open: "open"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsAccordionHorizontalItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsAccordionHorizontalItem = __decorate([ProxyCmp({
    inputs: ['headline', 'icon', 'open']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsAccordionHorizontalItem);
  return SewWsAccordionHorizontalItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsAnimatedNumbers = /*#__PURE__*/(() => {
  let SewWsAnimatedNumbers = class SewWsAnimatedNumbers {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsAnimatedNumbers_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsAnimatedNumbers)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsAnimatedNumbers,
      selectors: [["sew-ws-animated-numbers"]],
      inputs: {
        theme: "theme"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsAnimatedNumbers_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsAnimatedNumbers = __decorate([ProxyCmp({
    inputs: ['theme']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsAnimatedNumbers);
  return SewWsAnimatedNumbers;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsAnimatedNumbersItem = /*#__PURE__*/(() => {
  let SewWsAnimatedNumbersItem = class SewWsAnimatedNumbersItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsAnimatedNumbersItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsAnimatedNumbersItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsAnimatedNumbersItem,
      selectors: [["sew-ws-animated-numbers-item"]],
      inputs: {
        number: "number",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsAnimatedNumbersItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsAnimatedNumbersItem = __decorate([ProxyCmp({
    inputs: ['number', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsAnimatedNumbersItem);
  return SewWsAnimatedNumbersItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsBarChart = /*#__PURE__*/(() => {
  let SewWsBarChart = class SewWsBarChart {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsBarChart_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsBarChart)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsBarChart,
      selectors: [["sew-ws-bar-chart"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsBarChart_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsBarChart = __decorate([ProxyCmp({
    inputs: ['headline'],
    methods: ['gsapResize', 'gsapBootstrap']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsBarChart);
  return SewWsBarChart;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsBarChartChart = /*#__PURE__*/(() => {
  let SewWsBarChartChart = class SewWsBarChartChart {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsBarChartChart_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsBarChartChart)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsBarChartChart,
      selectors: [["sew-ws-bar-chart-chart"]],
      inputs: {
        legend: "legend"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsBarChartChart_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsBarChartChart = __decorate([ProxyCmp({
    inputs: ['legend']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsBarChartChart);
  return SewWsBarChartChart;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsBarChartNumbers = /*#__PURE__*/(() => {
  let SewWsBarChartNumbers = class SewWsBarChartNumbers {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsBarChartNumbers_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsBarChartNumbers)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsBarChartNumbers,
      selectors: [["sew-ws-bar-chart-numbers"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsBarChartNumbers_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsBarChartNumbers = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsBarChartNumbers);
  return SewWsBarChartNumbers;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsBarChartNumbersItem = /*#__PURE__*/(() => {
  let SewWsBarChartNumbersItem = class SewWsBarChartNumbersItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsBarChartNumbersItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsBarChartNumbersItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsBarChartNumbersItem,
      selectors: [["sew-ws-bar-chart-numbers-item"]],
      inputs: {
        headline: "headline",
        locale: "locale",
        number: "number",
        subline: "subline",
        unit: "unit"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsBarChartNumbersItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsBarChartNumbersItem = __decorate([ProxyCmp({
    inputs: ['headline', 'locale', 'number', 'subline', 'unit'],
    methods: ['startCount']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsBarChartNumbersItem);
  return SewWsBarChartNumbersItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsBasket = /*#__PURE__*/(() => {
  let SewWsBasket = class SewWsBasket {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['showBasket', 'counter']);
    }
    static ɵfac = function SewWsBasket_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsBasket)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsBasket,
      selectors: [["sew-ws-basket"]],
      inputs: {
        basketItems: "basketItems",
        labels: "labels",
        links: "links"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsBasket_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsBasket = __decorate([ProxyCmp({
    inputs: ['basketItems', 'labels', 'links']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsBasket);
  return SewWsBasket;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsBreadcrumb = /*#__PURE__*/(() => {
  let SewWsBreadcrumb = class SewWsBreadcrumb {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsBreadcrumb_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsBreadcrumb)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsBreadcrumb,
      selectors: [["sew-ws-breadcrumb"]],
      inputs: {
        links: "links",
        noGrid: "noGrid",
        noMargin: "noMargin"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsBreadcrumb_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsBreadcrumb = __decorate([ProxyCmp({
    inputs: ['links', 'noGrid', 'noMargin']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsBreadcrumb);
  return SewWsBreadcrumb;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsBulletlist = /*#__PURE__*/(() => {
  let SewWsBulletlist = class SewWsBulletlist {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsBulletlist_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsBulletlist)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsBulletlist,
      selectors: [["sew-ws-bulletlist"]],
      inputs: {
        ordered: "ordered"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsBulletlist_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsBulletlist = __decorate([ProxyCmp({
    inputs: ['ordered']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsBulletlist);
  return SewWsBulletlist;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsButton = /*#__PURE__*/(() => {
  let SewWsButton = class SewWsButton {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['buttonIsSqueezed']);
    }
    static ɵfac = function SewWsButton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsButton,
      selectors: [["sew-ws-button"]],
      inputs: {
        counter: "counter",
        ellipsis: "ellipsis",
        fullWidth: "fullWidth",
        hierarchy: "hierarchy",
        icon: "icon",
        loading: "loading",
        showIconOnly: "showIconOnly",
        size: "size"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsButton_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsButton = __decorate([ProxyCmp({
    inputs: ['counter', 'ellipsis', 'fullWidth', 'hierarchy', 'icon', 'loading', 'showIconOnly', 'size']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsButton);
  return SewWsButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsCareer = /*#__PURE__*/(() => {
  let SewWsCareer = class SewWsCareer {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsCareer_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsCareer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsCareer,
      selectors: [["sew-ws-career"]],
      inputs: {
        headline: "headline",
        noGrid: "noGrid",
        noMargin: "noMargin",
        subline: "subline",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsCareer_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsCareer = __decorate([ProxyCmp({
    inputs: ['headline', 'noGrid', 'noMargin', 'subline', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsCareer);
  return SewWsCareer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsCareerSlide = /*#__PURE__*/(() => {
  let SewWsCareerSlide = class SewWsCareerSlide {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsCareerSlide_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsCareerSlide)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsCareerSlide,
      selectors: [["sew-ws-career-slide"]],
      inputs: {
        active: "active",
        description: "description",
        value: "value"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsCareerSlide_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsCareerSlide = __decorate([ProxyCmp({
    inputs: ['active', 'description', 'value']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsCareerSlide);
  return SewWsCareerSlide;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsCircleTeaser = /*#__PURE__*/(() => {
  let SewWsCircleTeaser = class SewWsCircleTeaser {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsCircleTeaser_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsCircleTeaser)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsCircleTeaser,
      selectors: [["sew-ws-circle-teaser"]],
      inputs: {
        headline: "headline",
        logoUrl: "logoUrl",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsCircleTeaser_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsCircleTeaser = __decorate([ProxyCmp({
    inputs: ['headline', 'logoUrl', 'text'],
    methods: ['gsapResize', 'gsapBootstrap']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsCircleTeaser);
  return SewWsCircleTeaser;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsCircleTeaserItem = /*#__PURE__*/(() => {
  let SewWsCircleTeaserItem = class SewWsCircleTeaserItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsCircleTeaserItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsCircleTeaserItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsCircleTeaserItem,
      selectors: [["sew-ws-circle-teaser-item"]],
      inputs: {
        headline: "headline",
        icon: "icon",
        toLeft: "toLeft"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsCircleTeaserItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsCircleTeaserItem = __decorate([ProxyCmp({
    inputs: ['headline', 'icon', 'toLeft'],
    methods: ['showFlyout', 'hideFlyout']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsCircleTeaserItem);
  return SewWsCircleTeaserItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsCircleTeaser2 = /*#__PURE__*/(() => {
  let SewWsCircleTeaser2 = class SewWsCircleTeaser2 {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsCircleTeaser2_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsCircleTeaser2)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsCircleTeaser2,
      selectors: [["sew-ws-circle-teaser2"]],
      inputs: {
        headline: "headline",
        logoUrl: "logoUrl",
        text: "text",
        theme: "theme"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsCircleTeaser2_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsCircleTeaser2 = __decorate([ProxyCmp({
    inputs: ['headline', 'logoUrl', 'text', 'theme'],
    methods: ['gsapResize', 'gsapBootstrap']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsCircleTeaser2);
  return SewWsCircleTeaser2;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsCircleTeaser2Item = /*#__PURE__*/(() => {
  let SewWsCircleTeaser2Item = class SewWsCircleTeaser2Item {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsCircleTeaser2Item_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsCircleTeaser2Item)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsCircleTeaser2Item,
      selectors: [["sew-ws-circle-teaser2-item"]],
      inputs: {
        headline: "headline",
        icon: "icon"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsCircleTeaser2Item_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsCircleTeaser2Item = __decorate([ProxyCmp({
    inputs: ['headline', 'icon']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsCircleTeaser2Item);
  return SewWsCircleTeaser2Item;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsCompareSlider = /*#__PURE__*/(() => {
  let SewWsCompareSlider = class SewWsCompareSlider {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsCompareSlider_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsCompareSlider)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsCompareSlider,
      selectors: [["sew-ws-compare-slider"]],
      inputs: {
        caption: "caption"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsCompareSlider_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsCompareSlider = __decorate([ProxyCmp({
    inputs: ['caption']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsCompareSlider);
  return SewWsCompareSlider;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsCompass = /*#__PURE__*/(() => {
  let SewWsCompass = class SewWsCompass {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['categoryChange', 'categoryHover']);
    }
    static ɵfac = function SewWsCompass_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsCompass)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsCompass,
      selectors: [["sew-ws-compass"]],
      inputs: {
        hoveredCategory: "hoveredCategory",
        productCategories: "productCategories"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsCompass_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsCompass = __decorate([ProxyCmp({
    inputs: ['hoveredCategory', 'productCategories']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsCompass);
  return SewWsCompass;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsCompassMenu = /*#__PURE__*/(() => {
  let SewWsCompassMenu = class SewWsCompassMenu {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['categoryChange', 'categoryHover']);
    }
    static ɵfac = function SewWsCompassMenu_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsCompassMenu)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsCompassMenu,
      selectors: [["sew-ws-compass-menu"]],
      inputs: {
        hoveredCategory: "hoveredCategory",
        open: "open",
        productCategories: "productCategories",
        selectedCategory: "selectedCategory"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsCompassMenu_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsCompassMenu = __decorate([ProxyCmp({
    inputs: ['hoveredCategory', 'open', 'productCategories', 'selectedCategory']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsCompassMenu);
  return SewWsCompassMenu;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsConnect = /*#__PURE__*/(() => {
  let SewWsConnect = class SewWsConnect {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsConnect_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsConnect)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsConnect,
      selectors: [["sew-ws-connect"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsConnect_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsConnect = __decorate([ProxyCmp({
    inputs: ['headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsConnect);
  return SewWsConnect;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsContactTeaser = /*#__PURE__*/(() => {
  let SewWsContactTeaser = class SewWsContactTeaser {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsContactTeaser_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsContactTeaser)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsContactTeaser,
      selectors: [["sew-ws-contact-teaser"]],
      inputs: {
        description: "description",
        faxLabel: "faxLabel",
        faxNumber: "faxNumber",
        headline: "headline",
        subheadline: "subheadline",
        telephoneLabel: "telephoneLabel",
        telephoneNumber: "telephoneNumber"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsContactTeaser_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsContactTeaser = __decorate([ProxyCmp({
    inputs: ['description', 'faxLabel', 'faxNumber', 'headline', 'subheadline', 'telephoneLabel', 'telephoneNumber']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsContactTeaser);
  return SewWsContactTeaser;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsContactTeaserLinklistSocial = /*#__PURE__*/(() => {
  let SewWsContactTeaserLinklistSocial = class SewWsContactTeaserLinklistSocial {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsContactTeaserLinklistSocial_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsContactTeaserLinklistSocial)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsContactTeaserLinklistSocial,
      selectors: [["sew-ws-contact-teaser-linklist-social"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsContactTeaserLinklistSocial_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsContactTeaserLinklistSocial = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsContactTeaserLinklistSocial);
  return SewWsContactTeaserLinklistSocial;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsContactTeaserSimple = /*#__PURE__*/(() => {
  let SewWsContactTeaserSimple = class SewWsContactTeaserSimple {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsContactTeaserSimple_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsContactTeaserSimple)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsContactTeaserSimple,
      selectors: [["sew-ws-contact-teaser-simple"]],
      inputs: {
        headline: "headline",
        supHeadline: "supHeadline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsContactTeaserSimple_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsContactTeaserSimple = __decorate([ProxyCmp({
    inputs: ['headline', 'supHeadline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsContactTeaserSimple);
  return SewWsContactTeaserSimple;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsContactWorldwide = /*#__PURE__*/(() => {
  let SewWsContactWorldwide = class SewWsContactWorldwide {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsContactWorldwide_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsContactWorldwide)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsContactWorldwide,
      selectors: [["sew-ws-contact-worldwide"]],
      inputs: {
        devMode: "devMode",
        disableConsentCheck: "disableConsentCheck",
        headline: "headline",
        imageBaseUrl: "imageBaseUrl",
        initialCountry: "initialCountry",
        locationImageBaseUrl: "locationImageBaseUrl",
        mapDataUrl: "mapDataUrl",
        mapNamesUrl: "mapNamesUrl",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsContactWorldwide_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsContactWorldwide = __decorate([ProxyCmp({
    inputs: ['devMode', 'disableConsentCheck', 'headline', 'imageBaseUrl', 'initialCountry', 'locationImageBaseUrl', 'mapDataUrl', 'mapNamesUrl', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsContactWorldwide);
  return SewWsContactWorldwide;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsContactWorldwideAddressList = /*#__PURE__*/(() => {
  let SewWsContactWorldwideAddressList = class SewWsContactWorldwideAddressList {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['addressClicked']);
    }
    static ɵfac = function SewWsContactWorldwideAddressList_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsContactWorldwideAddressList)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsContactWorldwideAddressList,
      selectors: [["sew-ws-contact-worldwide-address-list"]],
      inputs: {
        addresses: "addresses",
        countryOfResult: "countryOfResult",
        imageBaseUrl: "imageBaseUrl",
        labels: "labels",
        open: "open"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsContactWorldwideAddressList_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsContactWorldwideAddressList = __decorate([ProxyCmp({
    inputs: ['addresses', 'countryOfResult', 'imageBaseUrl', 'labels', 'open']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsContactWorldwideAddressList);
  return SewWsContactWorldwideAddressList;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsContactWorldwideDirections = /*#__PURE__*/(() => {
  let SewWsContactWorldwideDirections = class SewWsContactWorldwideDirections {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['closeDirections', 'locationChange']);
    }
    static ɵfac = function SewWsContactWorldwideDirections_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsContactWorldwideDirections)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsContactWorldwideDirections,
      selectors: [["sew-ws-contact-worldwide-directions"]],
      inputs: {
        destinationLocation: "destinationLocation",
        disableConsentCheck: "disableConsentCheck",
        labels: "labels",
        localization: "localization",
        locationImageBaseUrl: "locationImageBaseUrl",
        open: "open",
        originLocation: "originLocation"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsContactWorldwideDirections_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsContactWorldwideDirections = __decorate([ProxyCmp({
    inputs: ['destinationLocation', 'disableConsentCheck', 'labels', 'localization', 'locationImageBaseUrl', 'open', 'originLocation']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsContactWorldwideDirections);
  return SewWsContactWorldwideDirections;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsContactWorldwideFilter = /*#__PURE__*/(() => {
  let SewWsContactWorldwideFilter = class SewWsContactWorldwideFilter {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['filterChange']);
    }
    static ɵfac = function SewWsContactWorldwideFilter_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsContactWorldwideFilter)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsContactWorldwideFilter,
      selectors: [["sew-ws-contact-worldwide-filter"]],
      inputs: {
        continents: "continents",
        countries: "countries",
        filterOptions: "filterOptions",
        labels: "labels",
        languageCode: "languageCode",
        locations: "locations",
        mapNames: "mapNames"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsContactWorldwideFilter_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsContactWorldwideFilter = __decorate([ProxyCmp({
    inputs: ['continents', 'countries', 'filterOptions', 'labels', 'languageCode', 'locations', 'mapNames']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsContactWorldwideFilter);
  return SewWsContactWorldwideFilter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsContactWorldwideTag = /*#__PURE__*/(() => {
  let SewWsContactWorldwideTag = class SewWsContactWorldwideTag {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['serviceChange', 'filterChange']);
    }
    static ɵfac = function SewWsContactWorldwideTag_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsContactWorldwideTag)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsContactWorldwideTag,
      selectors: [["sew-ws-contact-worldwide-tag"]],
      inputs: {
        filterOptions: "filterOptions",
        labels: "labels"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsContactWorldwideTag_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsContactWorldwideTag = __decorate([ProxyCmp({
    inputs: ['filterOptions', 'labels']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsContactWorldwideTag);
  return SewWsContactWorldwideTag;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsContentToggle = /*#__PURE__*/(() => {
  let SewWsContentToggle = class SewWsContentToggle {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsContentToggle_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsContentToggle)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsContentToggle,
      selectors: [["sew-ws-content-toggle"]],
      inputs: {
        expanded: "expanded"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsContentToggle_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsContentToggle = __decorate([ProxyCmp({
    inputs: ['expanded']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsContentToggle);
  return SewWsContentToggle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsContentWrapper = /*#__PURE__*/(() => {
  let SewWsContentWrapper = class SewWsContentWrapper {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsContentWrapper_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsContentWrapper)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsContentWrapper,
      selectors: [["sew-ws-content-wrapper"]],
      inputs: {
        limitContentWidth: "limitContentWidth",
        noGrid: "noGrid",
        noMargin: "noMargin",
        underlay: "underlay"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsContentWrapper_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsContentWrapper = __decorate([ProxyCmp({
    inputs: ['limitContentWidth', 'noGrid', 'noMargin', 'underlay']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsContentWrapper);
  return SewWsContentWrapper;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsCta = /*#__PURE__*/(() => {
  let SewWsCta = class SewWsCta {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsCta_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsCta)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsCta,
      selectors: [["sew-ws-cta"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsCta_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsCta = __decorate([ProxyCmp({
    inputs: ['headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsCta);
  return SewWsCta;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsCurtainSlideshow = /*#__PURE__*/(() => {
  let SewWsCurtainSlideshow = class SewWsCurtainSlideshow {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsCurtainSlideshow_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsCurtainSlideshow)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsCurtainSlideshow,
      selectors: [["sew-ws-curtain-slideshow"]],
      inputs: {
        triggerDistance: "triggerDistance"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsCurtainSlideshow_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsCurtainSlideshow = __decorate([ProxyCmp({
    inputs: ['triggerDistance'],
    methods: ['gsapResize', 'gsapBootstrap']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsCurtainSlideshow);
  return SewWsCurtainSlideshow;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsCurtainSlideshowItem = /*#__PURE__*/(() => {
  let SewWsCurtainSlideshowItem = class SewWsCurtainSlideshowItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsCurtainSlideshowItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsCurtainSlideshowItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsCurtainSlideshowItem,
      selectors: [["sew-ws-curtain-slideshow-item"]],
      inputs: {
        headline: "headline",
        shrink: "shrink"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsCurtainSlideshowItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsCurtainSlideshowItem = __decorate([ProxyCmp({
    inputs: ['headline', 'shrink']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsCurtainSlideshowItem);
  return SewWsCurtainSlideshowItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsCurtainSlideshow2 = /*#__PURE__*/(() => {
  let SewWsCurtainSlideshow2 = class SewWsCurtainSlideshow2 {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsCurtainSlideshow2_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsCurtainSlideshow2)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsCurtainSlideshow2,
      selectors: [["sew-ws-curtain-slideshow2"]],
      inputs: {
        headline: "headline",
        text: "text",
        theme: "theme"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsCurtainSlideshow2_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsCurtainSlideshow2 = __decorate([ProxyCmp({
    inputs: ['headline', 'text', 'theme'],
    methods: ['gsapResize', 'gsapBootstrap']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsCurtainSlideshow2);
  return SewWsCurtainSlideshow2;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsCurtainSlideshow2Item = /*#__PURE__*/(() => {
  let SewWsCurtainSlideshow2Item = class SewWsCurtainSlideshow2Item {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsCurtainSlideshow2Item_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsCurtainSlideshow2Item)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsCurtainSlideshow2Item,
      selectors: [["sew-ws-curtain-slideshow2-item"]],
      inputs: {
        even: "even",
        number: "number",
        odd: "odd"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsCurtainSlideshow2Item_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsCurtainSlideshow2Item = __decorate([ProxyCmp({
    inputs: ['even', 'number', 'odd']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsCurtainSlideshow2Item);
  return SewWsCurtainSlideshow2Item;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsDownloadList = /*#__PURE__*/(() => {
  let SewWsDownloadList = class SewWsDownloadList {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsDownloadList_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsDownloadList)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsDownloadList,
      selectors: [["sew-ws-download-list"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsDownloadList_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsDownloadList = __decorate([ProxyCmp({
    inputs: ['headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsDownloadList);
  return SewWsDownloadList;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsDownloadListItem = /*#__PURE__*/(() => {
  let SewWsDownloadListItem = class SewWsDownloadListItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsDownloadListItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsDownloadListItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsDownloadListItem,
      selectors: [["sew-ws-download-list-item"]],
      inputs: {
        description: "description",
        downloadLink: "downloadLink",
        name: "name"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsDownloadListItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsDownloadListItem = __decorate([ProxyCmp({
    inputs: ['description', 'downloadLink', 'name']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsDownloadListItem);
  return SewWsDownloadListItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsDownloads = /*#__PURE__*/(() => {
  let SewWsDownloads = class SewWsDownloads {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsDownloads_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsDownloads)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsDownloads,
      selectors: [["sew-ws-downloads"]],
      inputs: {
        allowSearchInput: "allowSearchInput",
        buttonText: "buttonText",
        downloadText: "downloadText",
        downloadTitle: "downloadTitle",
        downloadTypes: "downloadTypes",
        linksHeadline: "linksHeadline",
        linksText: "linksText",
        productInputTitle: "productInputTitle",
        searchInputLabel: "searchInputLabel",
        selectedDownloadType: "selectedDownloadType",
        servicesItemLabel: "servicesItemLabel",
        trackingCategory: "trackingCategory"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsDownloads_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsDownloads = __decorate([ProxyCmp({
    inputs: ['allowSearchInput', 'buttonText', 'downloadText', 'downloadTitle', 'downloadTypes', 'linksHeadline', 'linksText', 'productInputTitle', 'searchInputLabel', 'selectedDownloadType', 'servicesItemLabel', 'trackingCategory']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsDownloads);
  return SewWsDownloads;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsDummy = /*#__PURE__*/(() => {
  let SewWsDummy = class SewWsDummy {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsDummy_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsDummy)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsDummy,
      selectors: [["sew-ws-dummy"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsDummy_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsDummy = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsDummy);
  return SewWsDummy;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsDynamicImageSlider = /*#__PURE__*/(() => {
  let SewWsDynamicImageSlider = class SewWsDynamicImageSlider {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsDynamicImageSlider_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsDynamicImageSlider)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsDynamicImageSlider,
      selectors: [["sew-ws-dynamic-image-slider"]],
      inputs: {
        noMargin: "noMargin"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsDynamicImageSlider_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsDynamicImageSlider = __decorate([ProxyCmp({
    inputs: ['noMargin']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsDynamicImageSlider);
  return SewWsDynamicImageSlider;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsDynamicImageSliderItem = /*#__PURE__*/(() => {
  let SewWsDynamicImageSliderItem = class SewWsDynamicImageSliderItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsDynamicImageSliderItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsDynamicImageSliderItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsDynamicImageSliderItem,
      selectors: [["sew-ws-dynamic-image-slider-item"]],
      inputs: {
        header: "header",
        text: "text",
        video: "video"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsDynamicImageSliderItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsDynamicImageSliderItem = __decorate([ProxyCmp({
    inputs: ['header', 'text', 'video']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsDynamicImageSliderItem);
  return SewWsDynamicImageSliderItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsDynamicScrollSlider = /*#__PURE__*/(() => {
  let SewWsDynamicScrollSlider = class SewWsDynamicScrollSlider {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsDynamicScrollSlider_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsDynamicScrollSlider)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsDynamicScrollSlider,
      selectors: [["sew-ws-dynamic-scroll-slider"]],
      inputs: {
        headline: "headline",
        introText: "introText"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsDynamicScrollSlider_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsDynamicScrollSlider = __decorate([ProxyCmp({
    inputs: ['headline', 'introText'],
    methods: ['gsapResize', 'gsapBootstrap']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsDynamicScrollSlider);
  return SewWsDynamicScrollSlider;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsDynamicScrollSliderItem = /*#__PURE__*/(() => {
  let SewWsDynamicScrollSliderItem = class SewWsDynamicScrollSliderItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsDynamicScrollSliderItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsDynamicScrollSliderItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsDynamicScrollSliderItem,
      selectors: [["sew-ws-dynamic-scroll-slider-item"]],
      inputs: {
        caption: "caption"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsDynamicScrollSliderItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsDynamicScrollSliderItem = __decorate([ProxyCmp({
    inputs: ['caption']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsDynamicScrollSliderItem);
  return SewWsDynamicScrollSliderItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsEmployeeQuotes = /*#__PURE__*/(() => {
  let SewWsEmployeeQuotes = class SewWsEmployeeQuotes {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsEmployeeQuotes_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsEmployeeQuotes)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsEmployeeQuotes,
      selectors: [["sew-ws-employee-quotes"]],
      inputs: {
        originalImageRatio: "originalImageRatio",
        tapText: "tapText"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsEmployeeQuotes_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsEmployeeQuotes = __decorate([ProxyCmp({
    inputs: ['originalImageRatio', 'tapText'],
    methods: ['gsapBootstrap', 'gsapResize']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsEmployeeQuotes);
  return SewWsEmployeeQuotes;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsEmployeeQuotesItem = /*#__PURE__*/(() => {
  let SewWsEmployeeQuotesItem = class SewWsEmployeeQuotesItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsEmployeeQuotesItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsEmployeeQuotesItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsEmployeeQuotesItem,
      selectors: [["sew-ws-employee-quotes-item"]],
      inputs: {
        author: "author",
        quote: "quote"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsEmployeeQuotesItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsEmployeeQuotesItem = __decorate([ProxyCmp({
    inputs: ['author', 'quote']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsEmployeeQuotesItem);
  return SewWsEmployeeQuotesItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsEvents = /*#__PURE__*/(() => {
  let SewWsEvents = class SewWsEvents {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsEvents_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsEvents)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsEvents,
      selectors: [["sew-ws-events"]],
      inputs: {
        headline: "headline",
        noGrid: "noGrid",
        noMargin: "noMargin",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsEvents_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsEvents = __decorate([ProxyCmp({
    inputs: ['headline', 'noGrid', 'noMargin', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsEvents);
  return SewWsEvents;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsEventsApi = /*#__PURE__*/(() => {
  let SewWsEventsApi = class SewWsEventsApi {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsEventsApi_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsEventsApi)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsEventsApi,
      selectors: [["sew-ws-events-api"]],
      inputs: {
        eventCalendarUrl: "eventCalendarUrl",
        global: "global",
        headline: "headline",
        local: "local",
        noGrid: "noGrid",
        noMargin: "noMargin",
        showMax: "showMax",
        textGlobal: "textGlobal",
        textLocal: "textLocal",
        url: "url"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsEventsApi_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsEventsApi = __decorate([ProxyCmp({
    inputs: ['eventCalendarUrl', 'global', 'headline', 'local', 'noGrid', 'noMargin', 'showMax', 'textGlobal', 'textLocal', 'url']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsEventsApi);
  return SewWsEventsApi;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsEventsItem = /*#__PURE__*/(() => {
  let SewWsEventsItem = class SewWsEventsItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsEventsItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsEventsItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsEventsItem,
      selectors: [["sew-ws-events-item"]],
      inputs: {
        date: "date",
        location: "location"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsEventsItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsEventsItem = __decorate([ProxyCmp({
    inputs: ['date', 'location']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsEventsItem);
  return SewWsEventsItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsEventsStartpage = /*#__PURE__*/(() => {
  let SewWsEventsStartpage = class SewWsEventsStartpage {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsEventsStartpage_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsEventsStartpage)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsEventsStartpage,
      selectors: [["sew-ws-events-startpage"]],
      inputs: {
        apiUrl: "apiUrl",
        devMode: "devMode"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsEventsStartpage_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsEventsStartpage = __decorate([ProxyCmp({
    inputs: ['apiUrl', 'devMode']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsEventsStartpage);
  return SewWsEventsStartpage;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsEventsTeaser = /*#__PURE__*/(() => {
  let SewWsEventsTeaser = class SewWsEventsTeaser {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsEventsTeaser_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsEventsTeaser)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsEventsTeaser,
      selectors: [["sew-ws-events-teaser"]],
      inputs: {
        address: "address",
        headline: "headline",
        icon: "icon",
        linkExternalUrl: "linkExternalUrl",
        linkText: "linkText",
        linkUrl: "linkUrl",
        topline: "topline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsEventsTeaser_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsEventsTeaser = __decorate([ProxyCmp({
    inputs: ['address', 'headline', 'icon', 'linkExternalUrl', 'linkText', 'linkUrl', 'topline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsEventsTeaser);
  return SewWsEventsTeaser;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFactsAndFigures = /*#__PURE__*/(() => {
  let SewWsFactsAndFigures = class SewWsFactsAndFigures {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFactsAndFigures_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFactsAndFigures)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFactsAndFigures,
      selectors: [["sew-ws-facts-and-figures"]],
      inputs: {
        debug: "debug",
        headline: "headline",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFactsAndFigures_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFactsAndFigures = __decorate([ProxyCmp({
    inputs: ['debug', 'headline', 'text'],
    methods: ['gsapResize', 'gsapBootstrap']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFactsAndFigures);
  return SewWsFactsAndFigures;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFactsAndFiguresItem = /*#__PURE__*/(() => {
  let SewWsFactsAndFiguresItem = class SewWsFactsAndFiguresItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFactsAndFiguresItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFactsAndFiguresItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFactsAndFiguresItem,
      selectors: [["sew-ws-facts-and-figures-item"]],
      inputs: {
        icon: "icon",
        locale: "locale",
        number: "number",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFactsAndFiguresItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFactsAndFiguresItem = __decorate([ProxyCmp({
    inputs: ['icon', 'locale', 'number', 'text'],
    methods: ['startCount']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFactsAndFiguresItem);
  return SewWsFactsAndFiguresItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFlipCard = /*#__PURE__*/(() => {
  let SewWsFlipCard = class SewWsFlipCard {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFlipCard_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFlipCard)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFlipCard,
      selectors: [["sew-ws-flip-card"]],
      inputs: {
        cardTitle: "cardTitle",
        icon: "icon",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFlipCard_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFlipCard = __decorate([ProxyCmp({
    inputs: ['cardTitle', 'icon', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFlipCard);
  return SewWsFlipCard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFlipCardSlider = /*#__PURE__*/(() => {
  let SewWsFlipCardSlider = class SewWsFlipCardSlider {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFlipCardSlider_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFlipCardSlider)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFlipCardSlider,
      selectors: [["sew-ws-flip-card-slider"]],
      inputs: {
        selectedCategory: "selectedCategory",
        selectedSubCategory: "selectedSubCategory"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFlipCardSlider_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFlipCardSlider = __decorate([ProxyCmp({
    inputs: ['selectedCategory', 'selectedSubCategory']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFlipCardSlider);
  return SewWsFlipCardSlider;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFloatingButtons = /*#__PURE__*/(() => {
  let SewWsFloatingButtons = class SewWsFloatingButtons {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFloatingButtons_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFloatingButtons)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFloatingButtons,
      selectors: [["sew-ws-floating-buttons"]],
      inputs: {
        apiBaseUrl: "apiBaseUrl",
        apiKey: "apiKey",
        cardTitle: "cardTitle",
        chatBtnText: "chatBtnText",
        chatBtnTitle: "chatBtnTitle",
        contactAriaLabel: "contactAriaLabel",
        downloadAriaLabel: "downloadAriaLabel",
        enableDownloads: "enableDownloads",
        enableIdleAnimation: "enableIdleAnimation",
        enableLinkButton: "enableLinkButton",
        enableTips: "enableTips",
        enableWhatsapp: "enableWhatsapp",
        externalZipcodeInputName: "externalZipcodeInputName",
        externalZipcodeSearch: "externalZipcodeSearch",
        firstPhoneHelpText: "firstPhoneHelpText",
        firstPhoneNumber: "firstPhoneNumber",
        firstPhoneTitle: "firstPhoneTitle",
        linkBtnIcon: "linkBtnIcon",
        linkBtnLink: "linkBtnLink",
        linkBtnText: "linkBtnText",
        localization: "localization",
        placeholder: "placeholder",
        scrollToTopAriaLabel: "scrollToTopAriaLabel",
        secondPhoneHelpText: "secondPhoneHelpText",
        secondPhoneNumber: "secondPhoneNumber",
        secondPhoneTitle: "secondPhoneTitle",
        thirdPhoneHelpText: "thirdPhoneHelpText",
        thirdPhoneNumber: "thirdPhoneNumber",
        thirdPhoneTitle: "thirdPhoneTitle",
        tipApiUrl: "tipApiUrl",
        tipDuration: "tipDuration",
        tipLabel: "tipLabel",
        tipOptOutLabel: "tipOptOutLabel",
        whatsappAriaLabel: "whatsappAriaLabel"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFloatingButtons_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFloatingButtons = __decorate([ProxyCmp({
    inputs: ['apiBaseUrl', 'apiKey', 'cardTitle', 'chatBtnText', 'chatBtnTitle', 'contactAriaLabel', 'downloadAriaLabel', 'enableDownloads', 'enableIdleAnimation', 'enableLinkButton', 'enableTips', 'enableWhatsapp', 'externalZipcodeInputName', 'externalZipcodeSearch', 'firstPhoneHelpText', 'firstPhoneNumber', 'firstPhoneTitle', 'linkBtnIcon', 'linkBtnLink', 'linkBtnText', 'localization', 'placeholder', 'scrollToTopAriaLabel', 'secondPhoneHelpText', 'secondPhoneNumber', 'secondPhoneTitle', 'thirdPhoneHelpText', 'thirdPhoneNumber', 'thirdPhoneTitle', 'tipApiUrl', 'tipDuration', 'tipLabel', 'tipOptOutLabel', 'whatsappAriaLabel']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFloatingButtons);
  return SewWsFloatingButtons;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFloatingButtonsApi = /*#__PURE__*/(() => {
  let SewWsFloatingButtonsApi = class SewWsFloatingButtonsApi {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFloatingButtonsApi_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFloatingButtonsApi)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFloatingButtonsApi,
      selectors: [["sew-ws-floating-buttons-api"]],
      inputs: {
        contactApiUrl: "contactApiUrl",
        enableDownloads: "enableDownloads",
        enableIdleAnimation: "enableIdleAnimation",
        enableLinkButton: "enableLinkButton",
        enableTips: "enableTips",
        linkBtnIcon: "linkBtnIcon",
        linkBtnLink: "linkBtnLink",
        linkBtnText: "linkBtnText"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFloatingButtonsApi_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFloatingButtonsApi = __decorate([ProxyCmp({
    inputs: ['contactApiUrl', 'enableDownloads', 'enableIdleAnimation', 'enableLinkButton', 'enableTips', 'linkBtnIcon', 'linkBtnLink', 'linkBtnText']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFloatingButtonsApi);
  return SewWsFloatingButtonsApi;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFloatingNavigation = /*#__PURE__*/(() => {
  let SewWsFloatingNavigation = class SewWsFloatingNavigation {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFloatingNavigation_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFloatingNavigation)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFloatingNavigation,
      selectors: [["sew-ws-floating-navigation"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFloatingNavigation_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFloatingNavigation = __decorate([ProxyCmp({
    inputs: ['headline'],
    methods: ['close']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFloatingNavigation);
  return SewWsFloatingNavigation;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFloatingTiles = /*#__PURE__*/(() => {
  let SewWsFloatingTiles = class SewWsFloatingTiles {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFloatingTiles_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFloatingTiles)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFloatingTiles,
      selectors: [["sew-ws-floating-tiles"]],
      inputs: {
        headline: "headline",
        noGrid: "noGrid",
        noMargin: "noMargin",
        text: "text",
        theme: "theme"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFloatingTiles_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFloatingTiles = __decorate([ProxyCmp({
    inputs: ['headline', 'noGrid', 'noMargin', 'text', 'theme']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFloatingTiles);
  return SewWsFloatingTiles;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFloatingTilesItem = /*#__PURE__*/(() => {
  let SewWsFloatingTilesItem = class SewWsFloatingTilesItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['floatingTilesItemClicked']);
    }
    static ɵfac = function SewWsFloatingTilesItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFloatingTilesItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFloatingTilesItem,
      selectors: [["sew-ws-floating-tiles-item"]],
      inputs: {
        headline: "headline",
        icon: "icon",
        open: "open",
        tileId: "tileId"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFloatingTilesItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFloatingTilesItem = __decorate([ProxyCmp({
    inputs: ['headline', 'icon', 'open', 'tileId'],
    methods: ['toggleItem']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFloatingTilesItem);
  return SewWsFloatingTilesItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFloor = /*#__PURE__*/(() => {
  let SewWsFloor = class SewWsFloor {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFloor_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFloor)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFloor,
      selectors: [["sew-ws-floor"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFloor_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFloor = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFloor);
  return SewWsFloor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFlyout = /*#__PURE__*/(() => {
  let SewWsFlyout = class SewWsFlyout {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['flyoutClosed']);
    }
    static ɵfac = function SewWsFlyout_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFlyout)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFlyout,
      selectors: [["sew-ws-flyout"]],
      inputs: {
        counter: "counter",
        fullscreen: "fullscreen",
        icon: "icon",
        iconLabel: "iconLabel",
        ignoreViewportWidth: "ignoreViewportWidth",
        username: "username"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFlyout_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFlyout = __decorate([ProxyCmp({
    inputs: ['counter', 'fullscreen', 'icon', 'iconLabel', 'ignoreViewportWidth', 'username'],
    methods: ['openFlyout', 'closeFlyout']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFlyout);
  return SewWsFlyout;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFooter = /*#__PURE__*/(() => {
  let SewWsFooter = class SewWsFooter {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFooter_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFooter)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFooter,
      selectors: [["sew-ws-footer"]],
      inputs: {
        copyright: "copyright",
        logo: "logo",
        noMargin: "noMargin"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFooter_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFooter = __decorate([ProxyCmp({
    inputs: ['copyright', 'logo', 'noMargin']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFooter);
  return SewWsFooter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFooterApi = /*#__PURE__*/(() => {
  let SewWsFooterApi = class SewWsFooterApi {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFooterApi_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFooterApi)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFooterApi,
      selectors: [["sew-ws-footer-api"]],
      inputs: {
        caasBaseUrl: "caasBaseUrl",
        countryCode: "countryCode",
        displayNewestBlogPost: "displayNewestBlogPost",
        language: "language",
        legalOnly: "legalOnly",
        noLogo: "noLogo",
        noMargin: "noMargin",
        noSocial: "noSocial"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFooterApi_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFooterApi = __decorate([ProxyCmp({
    inputs: ['caasBaseUrl', 'countryCode', 'displayNewestBlogPost', 'language', 'legalOnly', 'noLogo', 'noMargin', 'noSocial']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFooterApi);
  return SewWsFooterApi;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFooterDummy = /*#__PURE__*/(() => {
  let SewWsFooterDummy = class SewWsFooterDummy {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFooterDummy_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFooterDummy)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFooterDummy,
      selectors: [["sew-ws-footer-dummy"]],
      inputs: {
        noMargin: "noMargin"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFooterDummy_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFooterDummy = __decorate([ProxyCmp({
    inputs: ['noMargin']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFooterDummy);
  return SewWsFooterDummy;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFooterLink = /*#__PURE__*/(() => {
  let SewWsFooterLink = class SewWsFooterLink {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFooterLink_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFooterLink)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFooterLink,
      selectors: [["sew-ws-footer-link"]],
      inputs: {
        headline: "headline",
        phoneNumber: "phoneNumber"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFooterLink_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFooterLink = __decorate([ProxyCmp({
    inputs: ['headline', 'phoneNumber']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFooterLink);
  return SewWsFooterLink;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFooterLinklist = /*#__PURE__*/(() => {
  let SewWsFooterLinklist = class SewWsFooterLinklist {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFooterLinklist_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFooterLinklist)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFooterLinklist,
      selectors: [["sew-ws-footer-linklist"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFooterLinklist_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFooterLinklist = __decorate([ProxyCmp({
    inputs: ['headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFooterLinklist);
  return SewWsFooterLinklist;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFooterLinklistLegal = /*#__PURE__*/(() => {
  let SewWsFooterLinklistLegal = class SewWsFooterLinklistLegal {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFooterLinklistLegal_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFooterLinklistLegal)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFooterLinklistLegal,
      selectors: [["sew-ws-footer-linklist-legal"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFooterLinklistLegal_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFooterLinklistLegal = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFooterLinklistLegal);
  return SewWsFooterLinklistLegal;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFooterLinklistSocial = /*#__PURE__*/(() => {
  let SewWsFooterLinklistSocial = class SewWsFooterLinklistSocial {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFooterLinklistSocial_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFooterLinklistSocial)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFooterLinklistSocial,
      selectors: [["sew-ws-footer-linklist-social"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFooterLinklistSocial_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFooterLinklistSocial = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFooterLinklistSocial);
  return SewWsFooterLinklistSocial;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFooterPhone = /*#__PURE__*/(() => {
  let SewWsFooterPhone = class SewWsFooterPhone {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFooterPhone_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFooterPhone)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFooterPhone,
      selectors: [["sew-ws-footer-phone"]],
      inputs: {
        headline: "headline",
        phoneNumber: "phoneNumber"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFooterPhone_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFooterPhone = __decorate([ProxyCmp({
    inputs: ['headline', 'phoneNumber']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFooterPhone);
  return SewWsFooterPhone;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFooterTeaser = /*#__PURE__*/(() => {
  let SewWsFooterTeaser = class SewWsFooterTeaser {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFooterTeaser_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFooterTeaser)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFooterTeaser,
      selectors: [["sew-ws-footer-teaser"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFooterTeaser_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFooterTeaser = __decorate([ProxyCmp({
    inputs: ['headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFooterTeaser);
  return SewWsFooterTeaser;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFullscreenQuote = /*#__PURE__*/(() => {
  let SewWsFullscreenQuote = class SewWsFullscreenQuote {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFullscreenQuote_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFullscreenQuote)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFullscreenQuote,
      selectors: [["sew-ws-fullscreen-quote"]],
      inputs: {
        author: "author",
        gsap: "gsap",
        quote: "quote"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFullscreenQuote_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFullscreenQuote = __decorate([ProxyCmp({
    inputs: ['author', 'gsap', 'quote'],
    methods: ['gsapResize', 'gsapBootstrap']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFullscreenQuote);
  return SewWsFullscreenQuote;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFullscreenTeaser = /*#__PURE__*/(() => {
  let SewWsFullscreenTeaser = class SewWsFullscreenTeaser {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFullscreenTeaser_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFullscreenTeaser)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFullscreenTeaser,
      selectors: [["sew-ws-fullscreen-teaser"]],
      inputs: {
        triggerDistance: "triggerDistance"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFullscreenTeaser_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFullscreenTeaser = __decorate([ProxyCmp({
    inputs: ['triggerDistance'],
    methods: ['gsapResize', 'gsapBootstrap']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFullscreenTeaser);
  return SewWsFullscreenTeaser;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFullscreenTeaserItem = /*#__PURE__*/(() => {
  let SewWsFullscreenTeaserItem = class SewWsFullscreenTeaserItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFullscreenTeaserItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFullscreenTeaserItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFullscreenTeaserItem,
      selectors: [["sew-ws-fullscreen-teaser-item"]],
      inputs: {
        headline: "headline",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFullscreenTeaserItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFullscreenTeaserItem = __decorate([ProxyCmp({
    inputs: ['headline', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFullscreenTeaserItem);
  return SewWsFullscreenTeaserItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFullscreenTeaser3 = /*#__PURE__*/(() => {
  let SewWsFullscreenTeaser3 = class SewWsFullscreenTeaser3 {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFullscreenTeaser3_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFullscreenTeaser3)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFullscreenTeaser3,
      selectors: [["sew-ws-fullscreen-teaser3"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFullscreenTeaser3_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFullscreenTeaser3 = __decorate([ProxyCmp({
    methods: ['gsapBootstrap']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFullscreenTeaser3);
  return SewWsFullscreenTeaser3;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsFullscreenTeaser3Item = /*#__PURE__*/(() => {
  let SewWsFullscreenTeaser3Item = class SewWsFullscreenTeaser3Item {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsFullscreenTeaser3Item_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsFullscreenTeaser3Item)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsFullscreenTeaser3Item,
      selectors: [["sew-ws-fullscreen-teaser3-item"]],
      inputs: {
        headline: "headline",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsFullscreenTeaser3Item_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsFullscreenTeaser3Item = __decorate([ProxyCmp({
    inputs: ['headline', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsFullscreenTeaser3Item);
  return SewWsFullscreenTeaser3Item;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsGrid = /*#__PURE__*/(() => {
  let SewWsGrid = class SewWsGrid {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsGrid_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsGrid)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsGrid,
      selectors: [["sew-ws-grid"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsGrid_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsGrid = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsGrid);
  return SewWsGrid;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsGrid16 = /*#__PURE__*/(() => {
  let SewWsGrid16 = class SewWsGrid16 {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsGrid16_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsGrid16)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsGrid16,
      selectors: [["sew-ws-grid-16"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsGrid16_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsGrid16 = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsGrid16);
  return SewWsGrid16;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsGridLimited = /*#__PURE__*/(() => {
  let SewWsGridLimited = class SewWsGridLimited {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsGridLimited_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsGridLimited)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsGridLimited,
      selectors: [["sew-ws-grid-limited"]],
      inputs: {
        headline: "headline",
        noMargin: "noMargin"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsGridLimited_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsGridLimited = __decorate([ProxyCmp({
    inputs: ['headline', 'noMargin']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsGridLimited);
  return SewWsGridLimited;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsGsap = /*#__PURE__*/(() => {
  let SewWsGsap = class SewWsGsap {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsGsap_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsGsap)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsGsap,
      selectors: [["sew-ws-gsap"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsGsap_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsGsap = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsGsap);
  return SewWsGsap;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsHeader = /*#__PURE__*/(() => {
  let SewWsHeader = class SewWsHeader {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['userChange', 'languageSwitch', 'countryShort', 'cmsProject', 'initComplete', 'labelsChange', 'projectMetaDataChange', 'permissionChange', 'componentDidRenderEvent', 'getTrackingService', 'accessToken']);
    }
    static ɵfac = function SewWsHeader_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsHeader)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsHeader,
      selectors: [["sew-ws-header"]],
      inputs: {
        apiBaseUrl: "apiBaseUrl",
        baseUrl: "baseUrl",
        breadcrumbId: "breadcrumbId",
        breadcrumbReady: "breadcrumbReady",
        caasBaseUrl: "caasBaseUrl",
        clientId: "clientId",
        countryCode: "countryCode",
        environment: "environment",
        hideBasket: "hideBasket",
        hideBreadcrumb: "hideBreadcrumb",
        hideLogin: "hideLogin",
        isPreview: "isPreview",
        loginUrl: "loginUrl",
        logoutUrl: "logoutUrl",
        minimalized: "minimalized",
        policy: "policy",
        postLogoutRedirectUri: "postLogoutRedirectUri",
        redirectUri: "redirectUri",
        scopes: "scopes",
        selectedLanguage: "selectedLanguage",
        small: "small",
        transparent: "transparent",
        transparentDesktopOnly: "transparentDesktopOnly",
        useCMP: "useCMP",
        useTracking: "useTracking",
        useWebchat: "useWebchat",
        zIndex: "zIndex"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsHeader_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsHeader = __decorate([ProxyCmp({
    inputs: ['apiBaseUrl', 'baseUrl', 'breadcrumbId', 'breadcrumbReady', 'caasBaseUrl', 'clientId', 'countryCode', 'environment', 'hideBasket', 'hideBreadcrumb', 'hideLogin', 'isPreview', 'loginUrl', 'logoutUrl', 'minimalized', 'policy', 'postLogoutRedirectUri', 'redirectUri', 'scopes', 'selectedLanguage', 'small', 'transparent', 'transparentDesktopOnly', 'useCMP', 'useTracking', 'useWebchat', 'zIndex'],
    methods: ['openBasket', 'openLogin']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsHeader);
  return SewWsHeader;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsHeaderDevmode = /*#__PURE__*/(() => {
  let SewWsHeaderDevmode = class SewWsHeaderDevmode {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['labelsChange', 'componentDidRenderEvent']);
    }
    static ɵfac = function SewWsHeaderDevmode_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsHeaderDevmode)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsHeaderDevmode,
      selectors: [["sew-ws-header-devmode"]],
      inputs: {
        breadcrumb: "breadcrumb",
        breadcrumbReady: "breadcrumbReady",
        ruler: "ruler",
        transparent: "transparent"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsHeaderDevmode_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsHeaderDevmode = __decorate([ProxyCmp({
    inputs: ['breadcrumb', 'breadcrumbReady', 'ruler', 'transparent']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsHeaderDevmode);
  return SewWsHeaderDevmode;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsHeroSlideInTeaser = /*#__PURE__*/(() => {
  let SewWsHeroSlideInTeaser = class SewWsHeroSlideInTeaser {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsHeroSlideInTeaser_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsHeroSlideInTeaser)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsHeroSlideInTeaser,
      selectors: [["sew-ws-hero-slide-in-teaser"]],
      inputs: {
        apiUrl: "apiUrl",
        btnText: "btnText",
        headline: "headline",
        sliderHeadline: "sliderHeadline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsHeroSlideInTeaser_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsHeroSlideInTeaser = __decorate([ProxyCmp({
    inputs: ['apiUrl', 'btnText', 'headline', 'sliderHeadline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsHeroSlideInTeaser);
  return SewWsHeroSlideInTeaser;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsHeroSlideInTeaserItem = /*#__PURE__*/(() => {
  let SewWsHeroSlideInTeaserItem = class SewWsHeroSlideInTeaserItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsHeroSlideInTeaserItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsHeroSlideInTeaserItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsHeroSlideInTeaserItem,
      selectors: [["sew-ws-hero-slide-in-teaser-item"]],
      inputs: {
        big: "big",
        country: "country",
        factory: "factory",
        headline: "headline",
        linkText: "linkText",
        linkUrl: "linkUrl"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsHeroSlideInTeaserItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsHeroSlideInTeaserItem = __decorate([ProxyCmp({
    inputs: ['big', 'country', 'factory', 'headline', 'linkText', 'linkUrl']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsHeroSlideInTeaserItem);
  return SewWsHeroSlideInTeaserItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsHeroimageWithTeaseroverlap = /*#__PURE__*/(() => {
  let SewWsHeroimageWithTeaseroverlap = class SewWsHeroimageWithTeaseroverlap {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsHeroimageWithTeaseroverlap_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsHeroimageWithTeaseroverlap)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsHeroimageWithTeaseroverlap,
      selectors: [["sew-ws-heroimage-with-teaseroverlap"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsHeroimageWithTeaseroverlap_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsHeroimageWithTeaseroverlap = __decorate([ProxyCmp({
    inputs: ['headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsHeroimageWithTeaseroverlap);
  return SewWsHeroimageWithTeaseroverlap;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsHttperror = /*#__PURE__*/(() => {
  let SewWsHttperror = class SewWsHttperror {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsHttperror_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsHttperror)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsHttperror,
      selectors: [["sew-ws-httperror"]],
      inputs: {
        headline: "headline",
        noGrid: "noGrid",
        noMargin: "noMargin"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsHttperror_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsHttperror = __decorate([ProxyCmp({
    inputs: ['headline', 'noGrid', 'noMargin']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsHttperror);
  return SewWsHttperror;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsImageMap = /*#__PURE__*/(() => {
  let SewWsImageMap = class SewWsImageMap {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsImageMap_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsImageMap)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsImageMap,
      selectors: [["sew-ws-image-map"]],
      inputs: {
        fallback: "fallback",
        items: "items"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsImageMap_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsImageMap = __decorate([ProxyCmp({
    inputs: ['fallback', 'items']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsImageMap);
  return SewWsImageMap;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsImageMapInfoLayer = /*#__PURE__*/(() => {
  let SewWsImageMapInfoLayer = class SewWsImageMapInfoLayer {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['close', 'watchlistChange']);
    }
    static ɵfac = function SewWsImageMapInfoLayer_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsImageMapInfoLayer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsImageMapInfoLayer,
      selectors: [["sew-ws-image-map-info-layer"]],
      inputs: {
        data: "data"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsImageMapInfoLayer_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsImageMapInfoLayer = __decorate([ProxyCmp({
    inputs: ['data']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsImageMapInfoLayer);
  return SewWsImageMapInfoLayer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsImageSlider = /*#__PURE__*/(() => {
  let SewWsImageSlider = class SewWsImageSlider {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsImageSlider_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsImageSlider)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsImageSlider,
      selectors: [["sew-ws-image-slider"]],
      inputs: {
        headline: "headline",
        noMargin: "noMargin"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsImageSlider_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsImageSlider = __decorate([ProxyCmp({
    inputs: ['headline', 'noMargin']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsImageSlider);
  return SewWsImageSlider;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsImageSliderItem = /*#__PURE__*/(() => {
  let SewWsImageSliderItem = class SewWsImageSliderItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsImageSliderItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsImageSliderItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsImageSliderItem,
      selectors: [["sew-ws-image-slider-item"]],
      inputs: {
        header: "header",
        text: "text",
        video: "video"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsImageSliderItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsImageSliderItem = __decorate([ProxyCmp({
    inputs: ['header', 'text', 'video']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsImageSliderItem);
  return SewWsImageSliderItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsImageStatsDisplay = /*#__PURE__*/(() => {
  let SewWsImageStatsDisplay = class SewWsImageStatsDisplay {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsImageStatsDisplay_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsImageStatsDisplay)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsImageStatsDisplay,
      selectors: [["sew-ws-image-stats-display"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsImageStatsDisplay_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsImageStatsDisplay = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsImageStatsDisplay);
  return SewWsImageStatsDisplay;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsImageStatsDisplayItem = /*#__PURE__*/(() => {
  let SewWsImageStatsDisplayItem = class SewWsImageStatsDisplayItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsImageStatsDisplayItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsImageStatsDisplayItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsImageStatsDisplayItem,
      selectors: [["sew-ws-image-stats-display-item"]],
      inputs: {
        number: "number",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsImageStatsDisplayItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsImageStatsDisplayItem = __decorate([ProxyCmp({
    inputs: ['number', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsImageStatsDisplayItem);
  return SewWsImageStatsDisplayItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsImageText = /*#__PURE__*/(() => {
  let SewWsImageText = class SewWsImageText {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsImageText_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsImageText)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsImageText,
      selectors: [["sew-ws-image-text"]],
      inputs: {
        headline: "headline",
        noGrid: "noGrid",
        noMargin: "noMargin",
        reverse: "reverse",
        size: "size",
        smallMargin: "smallMargin",
        underlay: "underlay"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsImageText_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsImageText = __decorate([ProxyCmp({
    inputs: ['headline', 'noGrid', 'noMargin', 'reverse', 'size', 'smallMargin', 'underlay']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsImageText);
  return SewWsImageText;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsImageTextFloat = /*#__PURE__*/(() => {
  let SewWsImageTextFloat = class SewWsImageTextFloat {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsImageTextFloat_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsImageTextFloat)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsImageTextFloat,
      selectors: [["sew-ws-image-text-float"]],
      inputs: {
        headline: "headline",
        noGrid: "noGrid",
        noMargin: "noMargin",
        reverse: "reverse"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsImageTextFloat_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsImageTextFloat = __decorate([ProxyCmp({
    inputs: ['headline', 'noGrid', 'noMargin', 'reverse']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsImageTextFloat);
  return SewWsImageTextFloat;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsImageTextFullscreen = /*#__PURE__*/(() => {
  let SewWsImageTextFullscreen = class SewWsImageTextFullscreen {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsImageTextFullscreen_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsImageTextFullscreen)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsImageTextFullscreen,
      selectors: [["sew-ws-image-text-fullscreen"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsImageTextFullscreen_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsImageTextFullscreen = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsImageTextFullscreen);
  return SewWsImageTextFullscreen;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsImageTextFullscreenItem = /*#__PURE__*/(() => {
  let SewWsImageTextFullscreenItem = class SewWsImageTextFullscreenItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsImageTextFullscreenItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsImageTextFullscreenItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsImageTextFullscreenItem,
      selectors: [["sew-ws-image-text-fullscreen-item"]],
      inputs: {
        reverse: "reverse"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsImageTextFullscreenItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsImageTextFullscreenItem = __decorate([ProxyCmp({
    inputs: ['reverse'],
    methods: ['gsapBootstrap']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsImageTextFullscreenItem);
  return SewWsImageTextFullscreenItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsImageTextRotation = /*#__PURE__*/(() => {
  let SewWsImageTextRotation = class SewWsImageTextRotation {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsImageTextRotation_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsImageTextRotation)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsImageTextRotation,
      selectors: [["sew-ws-image-text-rotation"]],
      inputs: {
        headline: "headline",
        inside: "inside",
        text: "text",
        theme: "theme"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsImageTextRotation_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsImageTextRotation = __decorate([ProxyCmp({
    inputs: ['headline', 'inside', 'text', 'theme'],
    methods: ['gsapResize', 'gsapBootstrap']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsImageTextRotation);
  return SewWsImageTextRotation;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsImageTextRotationItem = /*#__PURE__*/(() => {
  let SewWsImageTextRotationItem = class SewWsImageTextRotationItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsImageTextRotationItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsImageTextRotationItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsImageTextRotationItem,
      selectors: [["sew-ws-image-text-rotation-item"]],
      inputs: {
        number: "number"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsImageTextRotationItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsImageTextRotationItem = __decorate([ProxyCmp({
    inputs: ['number']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsImageTextRotationItem);
  return SewWsImageTextRotationItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsImageTextTriple = /*#__PURE__*/(() => {
  let SewWsImageTextTriple = class SewWsImageTextTriple {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsImageTextTriple_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsImageTextTriple)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsImageTextTriple,
      selectors: [["sew-ws-image-text-triple"]],
      inputs: {
        noMargin: "noMargin"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsImageTextTriple_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsImageTextTriple = __decorate([ProxyCmp({
    inputs: ['noMargin']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsImageTextTriple);
  return SewWsImageTextTriple;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsImageZoom = /*#__PURE__*/(() => {
  let SewWsImageZoom = class SewWsImageZoom {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsImageZoom_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsImageZoom)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsImageZoom,
      selectors: [["sew-ws-image-zoom"]],
      inputs: {
        closeAriaLabel: "closeAriaLabel",
        zoomAriaLabel: "zoomAriaLabel"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsImageZoom_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsImageZoom = __decorate([ProxyCmp({
    inputs: ['closeAriaLabel', 'zoomAriaLabel']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsImageZoom);
  return SewWsImageZoom;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsIndustries = /*#__PURE__*/(() => {
  let SewWsIndustries = class SewWsIndustries {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsIndustries_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsIndustries)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsIndustries,
      selectors: [["sew-ws-industries"]],
      inputs: {
        apiUrl: "apiUrl",
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsIndustries_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsIndustries = __decorate([ProxyCmp({
    inputs: ['apiUrl', 'headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsIndustries);
  return SewWsIndustries;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsInfoTiles = /*#__PURE__*/(() => {
  let SewWsInfoTiles = class SewWsInfoTiles {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsInfoTiles_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsInfoTiles)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsInfoTiles,
      selectors: [["sew-ws-info-tiles"]],
      inputs: {
        headline: "headline",
        text: "text",
        theme: "theme"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsInfoTiles_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsInfoTiles = __decorate([ProxyCmp({
    inputs: ['headline', 'text', 'theme']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsInfoTiles);
  return SewWsInfoTiles;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsInfoTilesItem = /*#__PURE__*/(() => {
  let SewWsInfoTilesItem = class SewWsInfoTilesItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsInfoTilesItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsInfoTilesItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsInfoTilesItem,
      selectors: [["sew-ws-info-tiles-item"]],
      inputs: {
        headline: "headline",
        headlineMobile: "headlineMobile",
        icon: "icon",
        number: "number",
        open: "open",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsInfoTilesItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsInfoTilesItem = __decorate([ProxyCmp({
    inputs: ['headline', 'headlineMobile', 'icon', 'number', 'open', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsInfoTilesItem);
  return SewWsInfoTilesItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsIntro = /*#__PURE__*/(() => {
  let SewWsIntro = class SewWsIntro {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsIntro_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsIntro)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsIntro,
      selectors: [["sew-ws-intro"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsIntro_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsIntro = __decorate([ProxyCmp({
    methods: ['gsapBootstrap']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsIntro);
  return SewWsIntro;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsLexfinder = /*#__PURE__*/(() => {
  let SewWsLexfinder = class SewWsLexfinder {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsLexfinder_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsLexfinder)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsLexfinder,
      selectors: [["sew-ws-lexfinder"]],
      inputs: {
        apiBaseUrl: "apiBaseUrl",
        buttonText: "buttonText",
        componentLabel: "componentLabel",
        countryLabel: "countryLabel",
        language: "language",
        regulationLabel: "regulationLabel",
        resultBaseUrl: "resultBaseUrl",
        servicesItemLabel: "servicesItemLabel",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsLexfinder_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsLexfinder = __decorate([ProxyCmp({
    inputs: ['apiBaseUrl', 'buttonText', 'componentLabel', 'countryLabel', 'language', 'regulationLabel', 'resultBaseUrl', 'servicesItemLabel', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsLexfinder);
  return SewWsLexfinder;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsLightbox = /*#__PURE__*/(() => {
  let SewWsLightbox = class SewWsLightbox {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsLightbox_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsLightbox)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsLightbox,
      selectors: [["sew-ws-lightbox"]],
      inputs: {
        contentSrc: "contentSrc",
        triggerSelector: "triggerSelector"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsLightbox_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsLightbox = __decorate([ProxyCmp({
    inputs: ['contentSrc', 'triggerSelector']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsLightbox);
  return SewWsLightbox;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsLink = /*#__PURE__*/(() => {
  let SewWsLink = class SewWsLink {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsLink_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsLink)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsLink,
      selectors: [["sew-ws-link"]],
      inputs: {
        os: "os",
        size: "size",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsLink_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsLink = __decorate([ProxyCmp({
    inputs: ['os', 'size', 'type']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsLink);
  return SewWsLink;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsLinkPanels = /*#__PURE__*/(() => {
  let SewWsLinkPanels = class SewWsLinkPanels {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsLinkPanels_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsLinkPanels)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsLinkPanels,
      selectors: [["sew-ws-link-panels"]],
      inputs: {
        headline: "headline",
        noGrid: "noGrid",
        noMargin: "noMargin"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsLinkPanels_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsLinkPanels = __decorate([ProxyCmp({
    inputs: ['headline', 'noGrid', 'noMargin']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsLinkPanels);
  return SewWsLinkPanels;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsLinkPanels2 = /*#__PURE__*/(() => {
  let SewWsLinkPanels2 = class SewWsLinkPanels2 {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsLinkPanels2_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsLinkPanels2)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsLinkPanels2,
      selectors: [["sew-ws-link-panels-2"]],
      inputs: {
        headline: "headline",
        theme: "theme"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsLinkPanels2_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsLinkPanels2 = __decorate([ProxyCmp({
    inputs: ['headline', 'theme']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsLinkPanels2);
  return SewWsLinkPanels2;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsLinkPanels2Item = /*#__PURE__*/(() => {
  let SewWsLinkPanels2Item = class SewWsLinkPanels2Item {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsLinkPanels2Item_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsLinkPanels2Item)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsLinkPanels2Item,
      selectors: [["sew-ws-link-panels-2-item"]],
      inputs: {
        headline: "headline",
        icon: "icon"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsLinkPanels2Item_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsLinkPanels2Item = __decorate([ProxyCmp({
    inputs: ['headline', 'icon']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsLinkPanels2Item);
  return SewWsLinkPanels2Item;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsLinkPanelsItem = /*#__PURE__*/(() => {
  let SewWsLinkPanelsItem = class SewWsLinkPanelsItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsLinkPanelsItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsLinkPanelsItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsLinkPanelsItem,
      selectors: [["sew-ws-link-panels-item"]],
      inputs: {
        headline: "headline",
        icon: "icon"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsLinkPanelsItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsLinkPanelsItem = __decorate([ProxyCmp({
    inputs: ['headline', 'icon']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsLinkPanelsItem);
  return SewWsLinkPanelsItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsLinklist = /*#__PURE__*/(() => {
  let SewWsLinklist = class SewWsLinklist {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsLinklist_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsLinklist)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsLinklist,
      selectors: [["sew-ws-linklist"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsLinklist_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsLinklist = __decorate([ProxyCmp({
    inputs: ['headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsLinklist);
  return SewWsLinklist;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsLinklistMenu = /*#__PURE__*/(() => {
  let SewWsLinklistMenu = class SewWsLinklistMenu {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsLinklistMenu_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsLinklistMenu)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsLinklistMenu,
      selectors: [["sew-ws-linklist-menu"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsLinklistMenu_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsLinklistMenu = __decorate([ProxyCmp({
    inputs: ['headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsLinklistMenu);
  return SewWsLinklistMenu;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsLocaleSwitch = /*#__PURE__*/(() => {
  let SewWsLocaleSwitch = class SewWsLocaleSwitch {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['switchLanguage', 'close']);
    }
    static ɵfac = function SewWsLocaleSwitch_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsLocaleSwitch)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsLocaleSwitch,
      selectors: [["sew-ws-locale-switch"]],
      inputs: {
        basketHasItems: "basketHasItems",
        countryCode: "countryCode",
        countrySelectorUrl: "countrySelectorUrl",
        httpClient: "httpClient",
        isPreview: "isPreview",
        labels: "labels",
        languageCode: "languageCode"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsLocaleSwitch_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsLocaleSwitch = __decorate([ProxyCmp({
    inputs: ['basketHasItems', 'countryCode', 'countrySelectorUrl', 'httpClient', 'isPreview', 'labels', 'languageCode'],
    methods: ['initCountries']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsLocaleSwitch);
  return SewWsLocaleSwitch;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsLocations = /*#__PURE__*/(() => {
  let SewWsLocations = class SewWsLocations {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsLocations_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsLocations)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsLocations,
      selectors: [["sew-ws-locations"]],
      inputs: {
        apiUrl: "apiUrl",
        dateApi: "dateApi",
        devMode: "devMode",
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsLocations_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsLocations = __decorate([ProxyCmp({
    inputs: ['apiUrl', 'dateApi', 'devMode', 'headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsLocations);
  return SewWsLocations;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsLocationsMap = /*#__PURE__*/(() => {
  let SewWsLocationsMap = class SewWsLocationsMap {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsLocationsMap_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsLocationsMap)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsLocationsMap,
      selectors: [["sew-ws-locations-map"]],
      inputs: {
        headline: "headline",
        legendDc: "legendDc",
        legendDtc: "legendDtc",
        legendRd: "legendRd",
        legendScc: "legendScc",
        legendTb: "legendTb",
        mapUrl: "mapUrl",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsLocationsMap_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsLocationsMap = __decorate([ProxyCmp({
    inputs: ['headline', 'legendDc', 'legendDtc', 'legendRd', 'legendScc', 'legendTb', 'mapUrl', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsLocationsMap);
  return SewWsLocationsMap;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsLocationsTeaser = /*#__PURE__*/(() => {
  let SewWsLocationsTeaser = class SewWsLocationsTeaser {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsLocationsTeaser_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsLocationsTeaser)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsLocationsTeaser,
      selectors: [["sew-ws-locations-teaser"]],
      inputs: {
        addressExpanded: "addressExpanded",
        directionsText: "directionsText",
        labels: "labels",
        language: "language",
        location: "location",
        showAddressText: "showAddressText"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsLocationsTeaser_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsLocationsTeaser = __decorate([ProxyCmp({
    inputs: ['addressExpanded', 'directionsText', 'labels', 'language', 'location', 'showAddressText']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsLocationsTeaser);
  return SewWsLocationsTeaser;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsLogin = /*#__PURE__*/(() => {
  let SewWsLogin = class SewWsLogin {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['login', 'logout']);
    }
    static ɵfac = function SewWsLogin_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsLogin)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsLogin,
      selectors: [["sew-ws-login"]],
      inputs: {
        baseUrl: "baseUrl",
        country: "country",
        labels: "labels",
        language: "language",
        nameError: "nameError",
        passwordError: "passwordError",
        user: "user"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsLogin_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsLogin = __decorate([ProxyCmp({
    inputs: ['baseUrl', 'country', 'labels', 'language', 'nameError', 'passwordError', 'user'],
    methods: ['setLoginError']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsLogin);
  return SewWsLogin;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsLoginForm = /*#__PURE__*/(() => {
  let SewWsLoginForm = class SewWsLoginForm {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsLoginForm_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsLoginForm)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsLoginForm,
      selectors: [["sew-ws-login-form"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsLoginForm_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsLoginForm = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsLoginForm);
  return SewWsLoginForm;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsMenuLink = /*#__PURE__*/(() => {
  let SewWsMenuLink = class SewWsMenuLink {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsMenuLink_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsMenuLink)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsMenuLink,
      selectors: [["sew-ws-menu-link"]],
      inputs: {
        current: "current",
        info: "info",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsMenuLink_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsMenuLink = __decorate([ProxyCmp({
    inputs: ['current', 'info', 'type']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsMenuLink);
  return SewWsMenuLink;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsMultiButton = /*#__PURE__*/(() => {
  let SewWsMultiButton = class SewWsMultiButton {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['clickedButton']);
    }
    static ɵfac = function SewWsMultiButton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsMultiButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsMultiButton,
      selectors: [["sew-ws-multi-button"]],
      inputs: {
        contactAriaLabel: "contactAriaLabel",
        downloadAriaLabel: "downloadAriaLabel",
        expanded: "expanded",
        initialAnimation: "initialAnimation",
        initialAnimationDuration: "initialAnimationDuration",
        whatsappAriaLabel: "whatsappAriaLabel"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsMultiButton_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsMultiButton = __decorate([ProxyCmp({
    inputs: ['contactAriaLabel', 'downloadAriaLabel', 'expanded', 'initialAnimation', 'initialAnimationDuration', 'whatsappAriaLabel']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsMultiButton);
  return SewWsMultiButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsNavigation = /*#__PURE__*/(() => {
  let SewWsNavigation = class SewWsNavigation {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['navigateLogin', 'notPermittedItemClicked', 'closeNavigation']);
    }
    static ɵfac = function SewWsNavigation_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsNavigation)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsNavigation,
      selectors: [["sew-ws-navigation"]],
      inputs: {
        hasMainNavigation: "hasMainNavigation",
        labels: "labels",
        language: "language",
        navHomeItem: "navHomeItem",
        permissions: "permissions",
        tracking: "tracking",
        user: "user"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsNavigation_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsNavigation = __decorate([ProxyCmp({
    inputs: ['hasMainNavigation', 'labels', 'language', 'navHomeItem', 'permissions', 'tracking', 'user']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsNavigation);
  return SewWsNavigation;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsNews = /*#__PURE__*/(() => {
  let SewWsNews = class SewWsNews {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsNews_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsNews)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsNews,
      selectors: [["sew-ws-news"]],
      inputs: {
        headline: "headline",
        noGrid: "noGrid",
        noMargin: "noMargin"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsNews_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsNews = __decorate([ProxyCmp({
    inputs: ['headline', 'noGrid', 'noMargin']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsNews);
  return SewWsNews;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsNewsApi = /*#__PURE__*/(() => {
  let SewWsNewsApi = class SewWsNewsApi {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsNewsApi_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsNewsApi)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsNewsApi,
      selectors: [["sew-ws-news-api"]],
      inputs: {
        headline: "headline",
        url: "url"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsNewsApi_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsNewsApi = __decorate([ProxyCmp({
    inputs: ['headline', 'url']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsNewsApi);
  return SewWsNewsApi;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsNewsContent = /*#__PURE__*/(() => {
  let SewWsNewsContent = class SewWsNewsContent {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsNewsContent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsNewsContent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsNewsContent,
      selectors: [["sew-ws-news-content"]],
      inputs: {
        date: "date",
        headline: "headline",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsNewsContent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsNewsContent = __decorate([ProxyCmp({
    inputs: ['date', 'headline', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsNewsContent);
  return SewWsNewsContent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsNewsFeed = /*#__PURE__*/(() => {
  let SewWsNewsFeed = class SewWsNewsFeed {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsNewsFeed_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsNewsFeed)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsNewsFeed,
      selectors: [["sew-ws-news-feed"]],
      inputs: {
        headline: "headline",
        noMargin: "noMargin"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsNewsFeed_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsNewsFeed = __decorate([ProxyCmp({
    inputs: ['headline', 'noMargin']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsNewsFeed);
  return SewWsNewsFeed;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsNewsFeedItem = /*#__PURE__*/(() => {
  let SewWsNewsFeedItem = class SewWsNewsFeedItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsNewsFeedItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsNewsFeedItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsNewsFeedItem,
      selectors: [["sew-ws-news-feed-item"]],
      inputs: {
        header: "header",
        text: "text",
        video: "video"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsNewsFeedItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsNewsFeedItem = __decorate([ProxyCmp({
    inputs: ['header', 'text', 'video']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsNewsFeedItem);
  return SewWsNewsFeedItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsNotification = /*#__PURE__*/(() => {
  let SewWsNotification = class SewWsNotification {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsNotification_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsNotification)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsNotification,
      selectors: [["sew-ws-notification"]],
      inputs: {
        duration: "duration",
        headline: "headline",
        message: "message"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsNotification_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsNotification = __decorate([ProxyCmp({
    inputs: ['duration', 'headline', 'message']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsNotification);
  return SewWsNotification;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsNotifications = /*#__PURE__*/(() => {
  let SewWsNotifications = class SewWsNotifications {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsNotifications_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsNotifications)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsNotifications,
      selectors: [["sew-ws-notifications"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsNotifications_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsNotifications = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsNotifications);
  return SewWsNotifications;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsOutro = /*#__PURE__*/(() => {
  let SewWsOutro = class SewWsOutro {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsOutro_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsOutro)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsOutro,
      selectors: [["sew-ws-outro"]],
      inputs: {
        headline: "headline",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsOutro_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsOutro = __decorate([ProxyCmp({
    inputs: ['headline', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsOutro);
  return SewWsOutro;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPageContentTeaser = /*#__PURE__*/(() => {
  let SewWsPageContentTeaser = class SewWsPageContentTeaser {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPageContentTeaser_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPageContentTeaser)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPageContentTeaser,
      selectors: [["sew-ws-page-content-teaser"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPageContentTeaser_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPageContentTeaser = __decorate([ProxyCmp({
    inputs: ['headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPageContentTeaser);
  return SewWsPageContentTeaser;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPageContentTeaserSimple = /*#__PURE__*/(() => {
  let SewWsPageContentTeaserSimple = class SewWsPageContentTeaserSimple {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPageContentTeaserSimple_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPageContentTeaserSimple)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPageContentTeaserSimple,
      selectors: [["sew-ws-page-content-teaser-simple"]],
      inputs: {
        headline: "headline",
        intro: "intro"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPageContentTeaserSimple_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPageContentTeaserSimple = __decorate([ProxyCmp({
    inputs: ['headline', 'intro']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPageContentTeaserSimple);
  return SewWsPageContentTeaserSimple;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsParagraph = /*#__PURE__*/(() => {
  let SewWsParagraph = class SewWsParagraph {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsParagraph_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsParagraph)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsParagraph,
      selectors: [["sew-ws-paragraph"]],
      inputs: {
        bold: "bold",
        size: "size"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsParagraph_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsParagraph = __decorate([ProxyCmp({
    inputs: ['bold', 'size']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsParagraph);
  return SewWsParagraph;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPasswordForgottenForm = /*#__PURE__*/(() => {
  let SewWsPasswordForgottenForm = class SewWsPasswordForgottenForm {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPasswordForgottenForm_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPasswordForgottenForm)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPasswordForgottenForm,
      selectors: [["sew-ws-password-forgotten-form"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPasswordForgottenForm_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPasswordForgottenForm = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPasswordForgottenForm);
  return SewWsPasswordForgottenForm;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPictureWrapper = /*#__PURE__*/(() => {
  let SewWsPictureWrapper = class SewWsPictureWrapper {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPictureWrapper_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPictureWrapper)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPictureWrapper,
      selectors: [["sew-ws-picture-wrapper"]],
      inputs: {
        noGrid: "noGrid",
        noMargin: "noMargin"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPictureWrapper_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPictureWrapper = __decorate([ProxyCmp({
    inputs: ['noGrid', 'noMargin']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPictureWrapper);
  return SewWsPictureWrapper;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPieChart = /*#__PURE__*/(() => {
  let SewWsPieChart = class SewWsPieChart {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPieChart_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPieChart)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPieChart,
      selectors: [["sew-ws-pie-chart"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPieChart_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPieChart = __decorate([ProxyCmp({
    inputs: ['headline'],
    methods: ['gsapResize', 'gsapBootstrap']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPieChart);
  return SewWsPieChart;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPieChartChart = /*#__PURE__*/(() => {
  let SewWsPieChartChart = class SewWsPieChartChart {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPieChartChart_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPieChartChart)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPieChartChart,
      selectors: [["sew-ws-pie-chart-chart"]],
      inputs: {
        chartUrl: "chartUrl"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPieChartChart_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPieChartChart = __decorate([ProxyCmp({
    inputs: ['chartUrl']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPieChartChart);
  return SewWsPieChartChart;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPieChartNumbers = /*#__PURE__*/(() => {
  let SewWsPieChartNumbers = class SewWsPieChartNumbers {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPieChartNumbers_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPieChartNumbers)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPieChartNumbers,
      selectors: [["sew-ws-pie-chart-numbers"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPieChartNumbers_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPieChartNumbers = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPieChartNumbers);
  return SewWsPieChartNumbers;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPieChartNumbersItem = /*#__PURE__*/(() => {
  let SewWsPieChartNumbersItem = class SewWsPieChartNumbersItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPieChartNumbersItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPieChartNumbersItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPieChartNumbersItem,
      selectors: [["sew-ws-pie-chart-numbers-item"]],
      inputs: {
        headline: "headline",
        headline2: "headline2",
        locale: "locale",
        number: "number",
        numberPre: "numberPre",
        subline: "subline",
        unit: "unit"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPieChartNumbersItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPieChartNumbersItem = __decorate([ProxyCmp({
    inputs: ['headline', 'headline2', 'locale', 'number', 'numberPre', 'subline', 'unit'],
    methods: ['startCount']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPieChartNumbersItem);
  return SewWsPieChartNumbersItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPieChartTooltip = /*#__PURE__*/(() => {
  let SewWsPieChartTooltip = class SewWsPieChartTooltip {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['tooltipToggle']);
    }
    static ɵfac = function SewWsPieChartTooltip_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPieChartTooltip)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPieChartTooltip,
      selectors: [["sew-ws-pie-chart-tooltip"]],
      inputs: {
        delay: "delay"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPieChartTooltip_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPieChartTooltip = __decorate([ProxyCmp({
    inputs: ['delay']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPieChartTooltip);
  return SewWsPieChartTooltip;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPodcast = /*#__PURE__*/(() => {
  let SewWsPodcast = class SewWsPodcast {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPodcast_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPodcast)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPodcast,
      selectors: [["sew-ws-podcast"]],
      inputs: {
        audioInfo: "audioInfo",
        closeAriaLabel: "closeAriaLabel",
        columns: "columns",
        forwardAriaLabel: "forwardAriaLabel",
        headline: "headline",
        muteAriaLabel: "muteAriaLabel",
        noGrid: "noGrid",
        noMargin: "noMargin",
        playAriaLabel: "playAriaLabel",
        rewindAriaLabel: "rewindAriaLabel",
        text: "text",
        thumbHeadline: "thumbHeadline",
        thumbText: "thumbText"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPodcast_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPodcast = __decorate([ProxyCmp({
    inputs: ['audioInfo', 'closeAriaLabel', 'columns', 'forwardAriaLabel', 'headline', 'muteAriaLabel', 'noGrid', 'noMargin', 'playAriaLabel', 'rewindAriaLabel', 'text', 'thumbHeadline', 'thumbText']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPodcast);
  return SewWsPodcast;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPopularBlogs = /*#__PURE__*/(() => {
  let SewWsPopularBlogs = class SewWsPopularBlogs {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPopularBlogs_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPopularBlogs)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPopularBlogs,
      selectors: [["sew-ws-popular-blogs"]],
      inputs: {
        apiUrl: "apiUrl",
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPopularBlogs_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPopularBlogs = __decorate([ProxyCmp({
    inputs: ['apiUrl', 'headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPopularBlogs);
  return SewWsPopularBlogs;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPopularBlogsItem = /*#__PURE__*/(() => {
  let SewWsPopularBlogsItem = class SewWsPopularBlogsItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPopularBlogsItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPopularBlogsItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPopularBlogsItem,
      selectors: [["sew-ws-popular-blogs-item"]],
      inputs: {
        blog: "blog"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPopularBlogsItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPopularBlogsItem = __decorate([ProxyCmp({
    inputs: ['blog']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPopularBlogsItem);
  return SewWsPopularBlogsItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPortfolio = /*#__PURE__*/(() => {
  let SewWsPortfolio = class SewWsPortfolio {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPortfolio_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPortfolio)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPortfolio,
      selectors: [["sew-ws-portfolio"]],
      inputs: {
        headline: "headline",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPortfolio_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPortfolio = __decorate([ProxyCmp({
    inputs: ['headline', 'text'],
    methods: ['gsapResize', 'gsapBootstrap']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPortfolio);
  return SewWsPortfolio;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPortfolioItem = /*#__PURE__*/(() => {
  let SewWsPortfolioItem = class SewWsPortfolioItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPortfolioItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPortfolioItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPortfolioItem,
      selectors: [["sew-ws-portfolio-item"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPortfolioItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPortfolioItem = __decorate([ProxyCmp({
    inputs: ['headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPortfolioItem);
  return SewWsPortfolioItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPortfolio2 = /*#__PURE__*/(() => {
  let SewWsPortfolio2 = class SewWsPortfolio2 {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPortfolio2_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPortfolio2)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPortfolio2,
      selectors: [["sew-ws-portfolio2"]],
      inputs: {
        headline: "headline",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPortfolio2_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPortfolio2 = __decorate([ProxyCmp({
    inputs: ['headline', 'text'],
    methods: ['gsapResize', 'gsapBootstrap']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPortfolio2);
  return SewWsPortfolio2;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPortfolio2Item = /*#__PURE__*/(() => {
  let SewWsPortfolio2Item = class SewWsPortfolio2Item {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPortfolio2Item_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPortfolio2Item)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPortfolio2Item,
      selectors: [["sew-ws-portfolio2-item"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPortfolio2Item_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPortfolio2Item = __decorate([ProxyCmp({
    inputs: ['headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPortfolio2Item);
  return SewWsPortfolio2Item;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPortraitTeaser2 = /*#__PURE__*/(() => {
  let SewWsPortraitTeaser2 = class SewWsPortraitTeaser2 {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPortraitTeaser2_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPortraitTeaser2)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPortraitTeaser2,
      selectors: [["sew-ws-portrait-teaser2"]],
      inputs: {
        headline: "headline",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPortraitTeaser2_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPortraitTeaser2 = __decorate([ProxyCmp({
    inputs: ['headline', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPortraitTeaser2);
  return SewWsPortraitTeaser2;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPortraitTeaser2Item = /*#__PURE__*/(() => {
  let SewWsPortraitTeaser2Item = class SewWsPortraitTeaser2Item {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPortraitTeaser2Item_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPortraitTeaser2Item)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPortraitTeaser2Item,
      selectors: [["sew-ws-portrait-teaser2-item"]],
      inputs: {
        headline: "headline",
        linkText: "linkText",
        linkUrl: "linkUrl",
        open: "open",
        subline: "subline",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPortraitTeaser2Item_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPortraitTeaser2Item = __decorate([ProxyCmp({
    inputs: ['headline', 'linkText', 'linkUrl', 'open', 'subline', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPortraitTeaser2Item);
  return SewWsPortraitTeaser2Item;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPressCenter = /*#__PURE__*/(() => {
  let SewWsPressCenter = class SewWsPressCenter {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPressCenter_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPressCenter)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPressCenter,
      selectors: [["sew-ws-press-center"]],
      inputs: {
        apiUrl: "apiUrl",
        dateApi: "dateApi",
        devMode: "devMode"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPressCenter_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPressCenter = __decorate([ProxyCmp({
    inputs: ['apiUrl', 'dateApi', 'devMode']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPressCenter);
  return SewWsPressCenter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPressCenterContactTeaser = /*#__PURE__*/(() => {
  let SewWsPressCenterContactTeaser = class SewWsPressCenterContactTeaser {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPressCenterContactTeaser_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPressCenterContactTeaser)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPressCenterContactTeaser,
      selectors: [["sew-ws-press-center-contact-teaser"]],
      inputs: {
        email: "email",
        linkedin: "linkedin",
        name: "name",
        pictureUrl: "pictureUrl",
        task: "task",
        telephoneLabel: "telephoneLabel",
        telephoneNumber: "telephoneNumber",
        xing: "xing"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPressCenterContactTeaser_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPressCenterContactTeaser = __decorate([ProxyCmp({
    inputs: ['email', 'linkedin', 'name', 'pictureUrl', 'task', 'telephoneLabel', 'telephoneNumber', 'xing']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPressCenterContactTeaser);
  return SewWsPressCenterContactTeaser;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsPressCenterTeaser = /*#__PURE__*/(() => {
  let SewWsPressCenterTeaser = class SewWsPressCenterTeaser {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsPressCenterTeaser_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsPressCenterTeaser)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsPressCenterTeaser,
      selectors: [["sew-ws-press-center-teaser"]],
      inputs: {
        date: "date",
        description: "description",
        downloadText: "downloadText",
        icon: "icon",
        linkUrl: "linkUrl",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsPressCenterTeaser_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsPressCenterTeaser = __decorate([ProxyCmp({
    inputs: ['date', 'description', 'downloadText', 'icon', 'linkUrl', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsPressCenterTeaser);
  return SewWsPressCenterTeaser;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsProductInfo = /*#__PURE__*/(() => {
  let SewWsProductInfo = class SewWsProductInfo {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsProductInfo_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsProductInfo)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsProductInfo,
      selectors: [["sew-ws-product-info"]],
      inputs: {
        headline: "headline",
        imgAlt: "imgAlt",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsProductInfo_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsProductInfo = __decorate([ProxyCmp({
    inputs: ['headline', 'imgAlt', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsProductInfo);
  return SewWsProductInfo;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsProductLinks = /*#__PURE__*/(() => {
  let SewWsProductLinks = class SewWsProductLinks {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsProductLinks_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsProductLinks)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsProductLinks,
      selectors: [["sew-ws-product-links"]],
      inputs: {
        headline: "headline",
        showLessLabel: "showLessLabel",
        showMoreLabel: "showMoreLabel"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsProductLinks_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsProductLinks = __decorate([ProxyCmp({
    inputs: ['headline', 'showLessLabel', 'showMoreLabel']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsProductLinks);
  return SewWsProductLinks;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsProductLinksItem = /*#__PURE__*/(() => {
  let SewWsProductLinksItem = class SewWsProductLinksItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsProductLinksItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsProductLinksItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsProductLinksItem,
      selectors: [["sew-ws-product-links-item"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsProductLinksItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsProductLinksItem = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsProductLinksItem);
  return SewWsProductLinksItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsProductSelection = /*#__PURE__*/(() => {
  let SewWsProductSelection = class SewWsProductSelection {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsProductSelection_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsProductSelection)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsProductSelection,
      selectors: [["sew-ws-product-selection"]],
      inputs: {
        headline: "headline",
        introText: "introText"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsProductSelection_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsProductSelection = __decorate([ProxyCmp({
    inputs: ['headline', 'introText']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsProductSelection);
  return SewWsProductSelection;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsProductSelectionItem = /*#__PURE__*/(() => {
  let SewWsProductSelectionItem = class SewWsProductSelectionItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsProductSelectionItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsProductSelectionItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsProductSelectionItem,
      selectors: [["sew-ws-product-selection-item"]],
      inputs: {
        description: "description",
        headline: "headline",
        icon: "icon"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsProductSelectionItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsProductSelectionItem = __decorate([ProxyCmp({
    inputs: ['description', 'headline', 'icon']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsProductSelectionItem);
  return SewWsProductSelectionItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsProductSelectionItemSlide = /*#__PURE__*/(() => {
  let SewWsProductSelectionItemSlide = class SewWsProductSelectionItemSlide {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['featureSlideEnd']);
    }
    static ɵfac = function SewWsProductSelectionItemSlide_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsProductSelectionItemSlide)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsProductSelectionItemSlide,
      selectors: [["sew-ws-product-selection-item-slide"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsProductSelectionItemSlide_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsProductSelectionItemSlide = __decorate([ProxyCmp({
    inputs: ['headline'],
    methods: ['startSlider', 'go']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsProductSelectionItemSlide);
  return SewWsProductSelectionItemSlide;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsProductfinder = /*#__PURE__*/(() => {
  let SewWsProductfinder = class SewWsProductfinder {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsProductfinder_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsProductfinder)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsProductfinder,
      selectors: [["sew-ws-productfinder"]],
      inputs: {
        productCategories: "productCategories"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsProductfinder_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsProductfinder = __decorate([ProxyCmp({
    inputs: ['productCategories']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsProductfinder);
  return SewWsProductfinder;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsProtectedLink = /*#__PURE__*/(() => {
  let SewWsProtectedLink = class SewWsProtectedLink {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsProtectedLink_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsProtectedLink)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsProtectedLink,
      selectors: [["sew-ws-protected-link"]],
      inputs: {
        authorizationRequired: "authorizationRequired",
        hideWhenLoggedIn: "hideWhenLoggedIn",
        level: "level",
        loginRequired: "loginRequired",
        os: "os",
        roleRequired: "roleRequired",
        size: "size",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsProtectedLink_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsProtectedLink = __decorate([ProxyCmp({
    inputs: ['authorizationRequired', 'hideWhenLoggedIn', 'level', 'loginRequired', 'os', 'roleRequired', 'size', 'type']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsProtectedLink);
  return SewWsProtectedLink;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsQuote = /*#__PURE__*/(() => {
  let SewWsQuote = class SewWsQuote {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsQuote_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsQuote)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsQuote,
      selectors: [["sew-ws-quote"]],
      inputs: {
        noGrid: "noGrid",
        noMargin: "noMargin"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsQuote_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsQuote = __decorate([ProxyCmp({
    inputs: ['noGrid', 'noMargin']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsQuote);
  return SewWsQuote;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsQuote2 = /*#__PURE__*/(() => {
  let SewWsQuote2 = class SewWsQuote2 {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsQuote2_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsQuote2)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsQuote2,
      selectors: [["sew-ws-quote2"]],
      inputs: {
        noGrid: "noGrid",
        noMargin: "noMargin"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsQuote2_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsQuote2 = __decorate([ProxyCmp({
    inputs: ['noGrid', 'noMargin']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsQuote2);
  return SewWsQuote2;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsReader = /*#__PURE__*/(() => {
  let SewWsReader = class SewWsReader {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsReader_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsReader)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsReader,
      selectors: [["sew-ws-reader"]],
      inputs: {
        buttonText: "buttonText",
        closeText: "closeText",
        forwardText: "forwardText",
        pauseText: "pauseText",
        playText: "playText",
        rewindText: "rewindText",
        speedText: "speedText",
        stopText: "stopText",
        volumeText: "volumeText"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsReader_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsReader = __decorate([ProxyCmp({
    inputs: ['buttonText', 'closeText', 'forwardText', 'pauseText', 'playText', 'rewindText', 'speedText', 'stopText', 'volumeText']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsReader);
  return SewWsReader;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsReferences = /*#__PURE__*/(() => {
  let SewWsReferences = class SewWsReferences {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsReferences_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsReferences)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsReferences,
      selectors: [["sew-ws-references"]],
      inputs: {
        apiUrl: "apiUrl",
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsReferences_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsReferences = __decorate([ProxyCmp({
    inputs: ['apiUrl', 'headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsReferences);
  return SewWsReferences;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsReferencesItem = /*#__PURE__*/(() => {
  let SewWsReferencesItem = class SewWsReferencesItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsReferencesItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsReferencesItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsReferencesItem,
      selectors: [["sew-ws-references-item"]],
      inputs: {
        linkName: "linkName",
        reference: "reference"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsReferencesItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsReferencesItem = __decorate([ProxyCmp({
    inputs: ['linkName', 'reference']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsReferencesItem);
  return SewWsReferencesItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsRegistrationExtendedForm = /*#__PURE__*/(() => {
  let SewWsRegistrationExtendedForm = class SewWsRegistrationExtendedForm {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsRegistrationExtendedForm_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsRegistrationExtendedForm)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsRegistrationExtendedForm,
      selectors: [["sew-ws-registration-extended-form"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsRegistrationExtendedForm_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsRegistrationExtendedForm = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsRegistrationExtendedForm);
  return SewWsRegistrationExtendedForm;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsRegistrationForm = /*#__PURE__*/(() => {
  let SewWsRegistrationForm = class SewWsRegistrationForm {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsRegistrationForm_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsRegistrationForm)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsRegistrationForm,
      selectors: [["sew-ws-registration-form"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsRegistrationForm_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsRegistrationForm = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsRegistrationForm);
  return SewWsRegistrationForm;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsReportPreRegistration = /*#__PURE__*/(() => {
  let SewWsReportPreRegistration = class SewWsReportPreRegistration {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsReportPreRegistration_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsReportPreRegistration)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsReportPreRegistration,
      selectors: [["sew-ws-report-pre-registration"]],
      inputs: {
        headline: "headline",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsReportPreRegistration_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsReportPreRegistration = __decorate([ProxyCmp({
    inputs: ['headline', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsReportPreRegistration);
  return SewWsReportPreRegistration;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsRichtext = /*#__PURE__*/(() => {
  let SewWsRichtext = class SewWsRichtext {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsRichtext_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsRichtext)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsRichtext,
      selectors: [["sew-ws-richtext"]],
      inputs: {
        large: "large",
        small: "small"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsRichtext_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsRichtext = __decorate([ProxyCmp({
    inputs: ['large', 'small']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsRichtext);
  return SewWsRichtext;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsRoadmap = /*#__PURE__*/(() => {
  let SewWsRoadmap = class SewWsRoadmap {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsRoadmap_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsRoadmap)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsRoadmap,
      selectors: [["sew-ws-roadmap"]],
      inputs: {
        headline: "headline",
        text: "text",
        theme: "theme"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsRoadmap_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsRoadmap = __decorate([ProxyCmp({
    inputs: ['headline', 'text', 'theme'],
    methods: ['gsapResize', 'gsapBootstrap']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsRoadmap);
  return SewWsRoadmap;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsRoadmapItem = /*#__PURE__*/(() => {
  let SewWsRoadmapItem = class SewWsRoadmapItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsRoadmapItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsRoadmapItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsRoadmapItem,
      selectors: [["sew-ws-roadmap-item"]],
      inputs: {
        checked: "checked",
        year: "year"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsRoadmapItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsRoadmapItem = __decorate([ProxyCmp({
    inputs: ['checked', 'year']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsRoadmapItem);
  return SewWsRoadmapItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsScrolldownIndicator = /*#__PURE__*/(() => {
  let SewWsScrolldownIndicator = class SewWsScrolldownIndicator {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsScrolldownIndicator_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsScrolldownIndicator)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsScrolldownIndicator,
      selectors: [["sew-ws-scrolldown-indicator"]],
      inputs: {
        duration: "duration",
        parentHost: "parentHost"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsScrolldownIndicator_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsScrolldownIndicator = __decorate([ProxyCmp({
    inputs: ['duration', 'parentHost']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsScrolldownIndicator);
  return SewWsScrolldownIndicator;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsSearch = /*#__PURE__*/(() => {
  let SewWsSearch = class SewWsSearch {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['fetchRecommendation', 'storeSearchHistory']);
    }
    static ɵfac = function SewWsSearch_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsSearch)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsSearch,
      selectors: [["sew-ws-search"]],
      inputs: {
        baseUrl: "baseUrl",
        country: "country",
        directLinks: "directLinks",
        labels: "labels",
        language: "language",
        latestSearchResults: "latestSearchResults",
        open: "open"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsSearch_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsSearch = __decorate([ProxyCmp({
    inputs: ['baseUrl', 'country', 'directLinks', 'labels', 'language', 'latestSearchResults', 'open'],
    methods: ['setRecommendations']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsSearch);
  return SewWsSearch;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsSearchLink = /*#__PURE__*/(() => {
  let SewWsSearchLink = class SewWsSearchLink {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsSearchLink_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsSearchLink)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsSearchLink,
      selectors: [["sew-ws-search-link"]],
      inputs: {
        headline: "headline",
        phoneNumber: "phoneNumber"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsSearchLink_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsSearchLink = __decorate([ProxyCmp({
    inputs: ['headline', 'phoneNumber']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsSearchLink);
  return SewWsSearchLink;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsSearchResult = /*#__PURE__*/(() => {
  let SewWsSearchResult = class SewWsSearchResult {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['searchTermChange']);
    }
    static ɵfac = function SewWsSearchResult_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsSearchResult)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsSearchResult,
      selectors: [["sew-ws-search-result"]],
      inputs: {
        alternativeLinksHeadline: "alternativeLinksHeadline",
        apiBaseUrl: "apiBaseUrl",
        currentCategory: "currentCategory",
        directLinksHeadline: "directLinksHeadline",
        directLinksShowLessLabel: "directLinksShowLessLabel",
        directLinksShowMoreLabel: "directLinksShowMoreLabel",
        downloadTypes: "downloadTypes",
        fuzzySearchLabel: "fuzzySearchLabel",
        loadingText: "loadingText",
        noSearchResultHeadline: "noSearchResultHeadline",
        noSearchResultInfo: "noSearchResultInfo",
        page: "page",
        productConfigLinkLabel: "productConfigLinkLabel",
        productLinkLabel: "productLinkLabel",
        searchFieldInfo: "searchFieldInfo",
        searchPageHeadline: "searchPageHeadline",
        searchParam: "searchParam",
        searchPlaceholder: "searchPlaceholder",
        searchResultHeadline: "searchResultHeadline",
        searchResultHeadlineSingular: "searchResultHeadlineSingular",
        searchResultListHeadline: "searchResultListHeadline",
        searchTerm: "searchTerm",
        showMoreBtnLabel: "showMoreBtnLabel",
        showProductHighlights: "showProductHighlights",
        suggestedLinksAsJson: "suggestedLinksAsJson",
        suggestedLinksHeadline: "suggestedLinksHeadline",
        switchLabel: "switchLabel",
        technicalDocumentLinkLabel: "technicalDocumentLinkLabel",
        videoHeadline: "videoHeadline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsSearchResult_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsSearchResult = __decorate([ProxyCmp({
    inputs: ['alternativeLinksHeadline', 'apiBaseUrl', 'currentCategory', 'directLinksHeadline', 'directLinksShowLessLabel', 'directLinksShowMoreLabel', 'downloadTypes', 'fuzzySearchLabel', 'loadingText', 'noSearchResultHeadline', 'noSearchResultInfo', 'page', 'productConfigLinkLabel', 'productLinkLabel', 'searchFieldInfo', 'searchPageHeadline', 'searchParam', 'searchPlaceholder', 'searchResultHeadline', 'searchResultHeadlineSingular', 'searchResultListHeadline', 'searchTerm', 'showMoreBtnLabel', 'showProductHighlights', 'suggestedLinksAsJson', 'suggestedLinksHeadline', 'switchLabel', 'technicalDocumentLinkLabel', 'videoHeadline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsSearchResult);
  return SewWsSearchResult;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsSearchSuggestions = /*#__PURE__*/(() => {
  let SewWsSearchSuggestions = class SewWsSearchSuggestions {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsSearchSuggestions_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsSearchSuggestions)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsSearchSuggestions,
      selectors: [["sew-ws-search-suggestions"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsSearchSuggestions_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsSearchSuggestions = __decorate([ProxyCmp({
    inputs: ['headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsSearchSuggestions);
  return SewWsSearchSuggestions;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsSearchresultList = /*#__PURE__*/(() => {
  let SewWsSearchresultList = class SewWsSearchresultList {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsSearchresultList_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsSearchresultList)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsSearchresultList,
      selectors: [["sew-ws-searchresult-list"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsSearchresultList_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsSearchresultList = __decorate([ProxyCmp({
    inputs: ['headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsSearchresultList);
  return SewWsSearchresultList;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsSearchresultListItem = /*#__PURE__*/(() => {
  let SewWsSearchresultListItem = class SewWsSearchresultListItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsSearchresultListItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsSearchresultListItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsSearchresultListItem,
      selectors: [["sew-ws-searchresult-list-item"]],
      inputs: {
        fileLanguage: "fileLanguage",
        fileLink: "fileLink",
        fileRelease: "fileRelease",
        fileSize: "fileSize",
        fileType: "fileType",
        isDoc: "isDoc",
        partNumber: "partNumber",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsSearchresultListItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsSearchresultListItem = __decorate([ProxyCmp({
    inputs: ['fileLanguage', 'fileLink', 'fileRelease', 'fileSize', 'fileType', 'isDoc', 'partNumber', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsSearchresultListItem);
  return SewWsSearchresultListItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsSectors = /*#__PURE__*/(() => {
  let SewWsSectors = class SewWsSectors {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsSectors_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsSectors)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsSectors,
      selectors: [["sew-ws-sectors"]],
      inputs: {
        headline: "headline",
        noGrid: "noGrid",
        noMargin: "noMargin"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsSectors_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsSectors = __decorate([ProxyCmp({
    inputs: ['headline', 'noGrid', 'noMargin']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsSectors);
  return SewWsSectors;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsSectorsItem = /*#__PURE__*/(() => {
  let SewWsSectorsItem = class SewWsSectorsItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsSectorsItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsSectorsItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsSectorsItem,
      selectors: [["sew-ws-sectors-item"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsSectorsItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsSectorsItem = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsSectorsItem);
  return SewWsSectorsItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsServices = /*#__PURE__*/(() => {
  let SewWsServices = class SewWsServices {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsServices_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsServices)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsServices,
      selectors: [["sew-ws-services"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsServices_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsServices = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsServices);
  return SewWsServices;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsServicesContact = /*#__PURE__*/(() => {
  let SewWsServicesContact = class SewWsServicesContact {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsServicesContact_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsServicesContact)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsServicesContact,
      selectors: [["sew-ws-services-contact"]],
      inputs: {
        apiUrl: "apiUrl",
        buttonText: "buttonText",
        errorMessage: "errorMessage",
        externalZipcodeInputName: "externalZipcodeInputName",
        externalZipcodeSearch: "externalZipcodeSearch",
        helpText: "helpText",
        phonePrefixLabel: "phonePrefixLabel",
        placeholder: "placeholder",
        servicesItemLabel: "servicesItemLabel"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsServicesContact_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsServicesContact = __decorate([ProxyCmp({
    inputs: ['apiUrl', 'buttonText', 'errorMessage', 'externalZipcodeInputName', 'externalZipcodeSearch', 'helpText', 'phonePrefixLabel', 'placeholder', 'servicesItemLabel']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsServicesContact);
  return SewWsServicesContact;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsServicesItem = /*#__PURE__*/(() => {
  let SewWsServicesItem = class SewWsServicesItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['itemClickedEmitter']);
    }
    static ɵfac = function SewWsServicesItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsServicesItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsServicesItem,
      selectors: [["sew-ws-services-item"]],
      inputs: {
        active: "active",
        icon: "icon",
        label: "label",
        openContent: "openContent",
        shortendLabel: "shortendLabel"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsServicesItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsServicesItem = __decorate([ProxyCmp({
    inputs: ['active', 'icon', 'label', 'openContent', 'shortendLabel']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsServicesItem);
  return SewWsServicesItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsServicesProduct = /*#__PURE__*/(() => {
  let SewWsServicesProduct = class SewWsServicesProduct {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsServicesProduct_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsServicesProduct)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsServicesProduct,
      selectors: [["sew-ws-services-product"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsServicesProduct_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsServicesProduct = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsServicesProduct);
  return SewWsServicesProduct;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsServicesReferences = /*#__PURE__*/(() => {
  let SewWsServicesReferences = class SewWsServicesReferences {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsServicesReferences_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsServicesReferences)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsServicesReferences,
      selectors: [["sew-ws-services-references"]],
      inputs: {
        apiUrl: "apiUrl"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsServicesReferences_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsServicesReferences = __decorate([ProxyCmp({
    inputs: ['apiUrl']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsServicesReferences);
  return SewWsServicesReferences;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsShowMore = /*#__PURE__*/(() => {
  let SewWsShowMore = class SewWsShowMore {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsShowMore_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsShowMore)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsShowMore,
      selectors: [["sew-ws-show-more"]],
      inputs: {
        headline: "headline",
        text: "text",
        textMinify: "textMinify"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsShowMore_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsShowMore = __decorate([ProxyCmp({
    inputs: ['headline', 'text', 'textMinify']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsShowMore);
  return SewWsShowMore;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsSlidetoggle = /*#__PURE__*/(() => {
  let SewWsSlidetoggle = class SewWsSlidetoggle {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsSlidetoggle_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsSlidetoggle)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsSlidetoggle,
      selectors: [["sew-ws-slidetoggle"]],
      inputs: {
        expanded: "expanded"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsSlidetoggle_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsSlidetoggle = __decorate([ProxyCmp({
    inputs: ['expanded']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsSlidetoggle);
  return SewWsSlidetoggle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsSlidetoggleContainer = /*#__PURE__*/(() => {
  let SewWsSlidetoggleContainer = class SewWsSlidetoggleContainer {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsSlidetoggleContainer_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsSlidetoggleContainer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsSlidetoggleContainer,
      selectors: [["sew-ws-slidetoggle-container"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsSlidetoggleContainer_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsSlidetoggleContainer = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsSlidetoggleContainer);
  return SewWsSlidetoggleContainer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsSocialMedia = /*#__PURE__*/(() => {
  let SewWsSocialMedia = class SewWsSocialMedia {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsSocialMedia_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsSocialMedia)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsSocialMedia,
      selectors: [["sew-ws-social-media"]],
      inputs: {
        caasBaseUrl: "caasBaseUrl",
        countryCode: "countryCode",
        devmode: "devmode",
        language: "language",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsSocialMedia_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsSocialMedia = __decorate([ProxyCmp({
    inputs: ['caasBaseUrl', 'countryCode', 'devmode', 'language', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsSocialMedia);
  return SewWsSocialMedia;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsSocialMediaOutro = /*#__PURE__*/(() => {
  let SewWsSocialMediaOutro = class SewWsSocialMediaOutro {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsSocialMediaOutro_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsSocialMediaOutro)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsSocialMediaOutro,
      selectors: [["sew-ws-social-media-outro"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsSocialMediaOutro_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsSocialMediaOutro = __decorate([ProxyCmp({
    inputs: ['headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsSocialMediaOutro);
  return SewWsSocialMediaOutro;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsSocialMediaOutroItem = /*#__PURE__*/(() => {
  let SewWsSocialMediaOutroItem = class SewWsSocialMediaOutroItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsSocialMediaOutroItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsSocialMediaOutroItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsSocialMediaOutroItem,
      selectors: [["sew-ws-social-media-outro-item"]],
      inputs: {
        headline: "headline",
        icon: "icon",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsSocialMediaOutroItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsSocialMediaOutroItem = __decorate([ProxyCmp({
    inputs: ['headline', 'icon', 'text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsSocialMediaOutroItem);
  return SewWsSocialMediaOutroItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsStage = /*#__PURE__*/(() => {
  let SewWsStage = class SewWsStage {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsStage_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsStage)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsStage,
      selectors: [["sew-ws-stage"]],
      inputs: {
        compact: "compact",
        showPager: "showPager"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsStage_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsStage = __decorate([ProxyCmp({
    inputs: ['compact', 'showPager']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsStage);
  return SewWsStage;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsStageHeadlineRotation = /*#__PURE__*/(() => {
  let SewWsStageHeadlineRotation = class SewWsStageHeadlineRotation {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsStageHeadlineRotation_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsStageHeadlineRotation)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsStageHeadlineRotation,
      selectors: [["sew-ws-stage-headline-rotation"]],
      inputs: {
        disableTextBgShadow: "disableTextBgShadow",
        small: "small",
        theme: "theme"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsStageHeadlineRotation_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsStageHeadlineRotation = __decorate([ProxyCmp({
    inputs: ['disableTextBgShadow', 'small', 'theme']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsStageHeadlineRotation);
  return SewWsStageHeadlineRotation;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsStageItem = /*#__PURE__*/(() => {
  let SewWsStageItem = class SewWsStageItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsStageItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsStageItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsStageItem,
      selectors: [["sew-ws-stage-item"]],
      inputs: {
        autoplay: "autoplay",
        compact: "compact",
        duration: "duration",
        headline: "headline",
        imageAlign: "imageAlign",
        index: "index",
        topicLine: "topicLine",
        videoTitle: "videoTitle"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsStageItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsStageItem = __decorate([ProxyCmp({
    inputs: ['autoplay', 'compact', 'duration', 'headline', 'imageAlign', 'index', 'topicLine', 'videoTitle']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsStageItem);
  return SewWsStageItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsStageParallax = /*#__PURE__*/(() => {
  let SewWsStageParallax = class SewWsStageParallax {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsStageParallax_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsStageParallax)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsStageParallax,
      selectors: [["sew-ws-stage-parallax"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsStageParallax_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsStageParallax = __decorate([ProxyCmp({
    inputs: ['headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsStageParallax);
  return SewWsStageParallax;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsStageTypeMotion = /*#__PURE__*/(() => {
  let SewWsStageTypeMotion = class SewWsStageTypeMotion {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsStageTypeMotion_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsStageTypeMotion)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsStageTypeMotion,
      selectors: [["sew-ws-stage-type-motion"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsStageTypeMotion_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsStageTypeMotion = __decorate([ProxyCmp({
    inputs: ['headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsStageTypeMotion);
  return SewWsStageTypeMotion;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsSubcategoryItemsView = /*#__PURE__*/(() => {
  let SewWsSubcategoryItemsView = class SewWsSubcategoryItemsView {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsSubcategoryItemsView_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsSubcategoryItemsView)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsSubcategoryItemsView,
      selectors: [["sew-ws-subcategory-items-view"]],
      inputs: {
        items: "items"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsSubcategoryItemsView_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsSubcategoryItemsView = __decorate([ProxyCmp({
    inputs: ['items']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsSubcategoryItemsView);
  return SewWsSubcategoryItemsView;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsTabNavigation = /*#__PURE__*/(() => {
  let SewWsTabNavigation = class SewWsTabNavigation {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsTabNavigation_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsTabNavigation)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsTabNavigation,
      selectors: [["sew-ws-tab-navigation"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsTabNavigation_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsTabNavigation = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsTabNavigation);
  return SewWsTabNavigation;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsTabNavigationItem = /*#__PURE__*/(() => {
  let SewWsTabNavigationItem = class SewWsTabNavigationItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['tabNavItemClicked']);
    }
    static ɵfac = function SewWsTabNavigationItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsTabNavigationItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsTabNavigationItem,
      selectors: [["sew-ws-tab-navigation-item"]],
      inputs: {
        active: "active"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsTabNavigationItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsTabNavigationItem = __decorate([ProxyCmp({
    inputs: ['active']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsTabNavigationItem);
  return SewWsTabNavigationItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsTable = /*#__PURE__*/(() => {
  let SewWsTable = class SewWsTable {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsTable_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsTable)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsTable,
      selectors: [["sew-ws-table"]],
      inputs: {
        labelHide: "labelHide",
        labelShow: "labelShow",
        limitHide: "limitHide",
        limitRows: "limitRows",
        limitShow: "limitShow",
        noMargin: "noMargin",
        sticky: "sticky",
        text: "text",
        zebra: "zebra"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsTable_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsTable = __decorate([ProxyCmp({
    inputs: ['labelHide', 'labelShow', 'limitHide', 'limitRows', 'limitShow', 'noMargin', 'sticky', 'text', 'zebra']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsTable);
  return SewWsTable;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsTabs = /*#__PURE__*/(() => {
  let SewWsTabs = class SewWsTabs {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsTabs_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsTabs)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsTabs,
      selectors: [["sew-ws-tabs"]],
      inputs: {
        headline: "headline",
        noContent: "noContent",
        noGrid: "noGrid",
        noMargin: "noMargin",
        scrollLeftAriaLabel: "scrollLeftAriaLabel",
        scrollRightAriaLabel: "scrollRightAriaLabel"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsTabs_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsTabs = __decorate([ProxyCmp({
    inputs: ['headline', 'noContent', 'noGrid', 'noMargin', 'scrollLeftAriaLabel', 'scrollRightAriaLabel']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsTabs);
  return SewWsTabs;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsTabsItem = /*#__PURE__*/(() => {
  let SewWsTabsItem = class SewWsTabsItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['activated']);
    }
    static ɵfac = function SewWsTabsItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsTabsItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsTabsItem,
      selectors: [["sew-ws-tabs-item"]],
      inputs: {
        active: "active",
        buttonHref: "buttonHref",
        name: "name",
        tabId: "tabId"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsTabsItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsTabsItem = __decorate([ProxyCmp({
    inputs: ['active', 'buttonHref', 'name', 'tabId']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsTabsItem);
  return SewWsTabsItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsTabsTable = /*#__PURE__*/(() => {
  let SewWsTabsTable = class SewWsTabsTable {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsTabsTable_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsTabsTable)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsTabsTable,
      selectors: [["sew-ws-tabs-table"]],
      inputs: {
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsTabsTable_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsTabsTable = __decorate([ProxyCmp({
    inputs: ['text']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsTabsTable);
  return SewWsTabsTable;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsTeaser = /*#__PURE__*/(() => {
  let SewWsTeaser = class SewWsTeaser {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsTeaser_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsTeaser)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsTeaser,
      selectors: [["sew-ws-teaser"]],
      inputs: {
        columns: "columns",
        headline: "headline",
        noGrid: "noGrid",
        noMargin: "noMargin"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsTeaser_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsTeaser = __decorate([ProxyCmp({
    inputs: ['columns', 'headline', 'noGrid', 'noMargin']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsTeaser);
  return SewWsTeaser;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsTeaserAccessoireItem = /*#__PURE__*/(() => {
  let SewWsTeaserAccessoireItem = class SewWsTeaserAccessoireItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsTeaserAccessoireItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsTeaserAccessoireItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsTeaserAccessoireItem,
      selectors: [["sew-ws-teaser-accessoire-item"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsTeaserAccessoireItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsTeaserAccessoireItem = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsTeaserAccessoireItem);
  return SewWsTeaserAccessoireItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsTeaserItem = /*#__PURE__*/(() => {
  let SewWsTeaserItem = class SewWsTeaserItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsTeaserItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsTeaserItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsTeaserItem,
      selectors: [["sew-ws-teaser-item"]],
      inputs: {
        headline: "headline",
        text: "text",
        video: "video"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsTeaserItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsTeaserItem = __decorate([ProxyCmp({
    inputs: ['headline', 'text', 'video']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsTeaserItem);
  return SewWsTeaserItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsTeaserPortraitItem = /*#__PURE__*/(() => {
  let SewWsTeaserPortraitItem = class SewWsTeaserPortraitItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsTeaserPortraitItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsTeaserPortraitItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsTeaserPortraitItem,
      selectors: [["sew-ws-teaser-portrait-item"]],
      inputs: {
        headline: "headline"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsTeaserPortraitItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsTeaserPortraitItem = __decorate([ProxyCmp({
    inputs: ['headline']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsTeaserPortraitItem);
  return SewWsTeaserPortraitItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsTeaserProductItem = /*#__PURE__*/(() => {
  let SewWsTeaserProductItem = class SewWsTeaserProductItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsTeaserProductItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsTeaserProductItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsTeaserProductItem,
      selectors: [["sew-ws-teaser-product-item"]],
      inputs: {
        headline: "headline",
        printLink: "printLink"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsTeaserProductItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsTeaserProductItem = __decorate([ProxyCmp({
    inputs: ['headline', 'printLink']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsTeaserProductItem);
  return SewWsTeaserProductItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsTextSplit = /*#__PURE__*/(() => {
  let SewWsTextSplit = class SewWsTextSplit {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsTextSplit_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsTextSplit)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsTextSplit,
      selectors: [["sew-ws-text-split"]],
      inputs: {
        noGrid: "noGrid",
        noMargin: "noMargin"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsTextSplit_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsTextSplit = __decorate([ProxyCmp({
    inputs: ['noGrid', 'noMargin']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsTextSplit);
  return SewWsTextSplit;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsTextanimation = /*#__PURE__*/(() => {
  let SewWsTextanimation = class SewWsTextanimation {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsTextanimation_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsTextanimation)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsTextanimation,
      selectors: [["sew-ws-textanimation"]],
      inputs: {
        gsap: "gsap",
        optionalText: "optionalText",
        optionalTextOIndex: "optionalTextOIndex",
        text: "text"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsTextanimation_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsTextanimation = __decorate([ProxyCmp({
    inputs: ['gsap', 'optionalText', 'optionalTextOIndex', 'text'],
    methods: ['gsapResize', 'gsapBootstrap']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsTextanimation);
  return SewWsTextanimation;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsThreesixty = /*#__PURE__*/(() => {
  let SewWsThreesixty = class SewWsThreesixty {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsThreesixty_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsThreesixty)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsThreesixty,
      selectors: [["sew-ws-threesixty"]],
      inputs: {
        caption: "caption",
        dataAmount: "dataAmount",
        imgAlt: "imgAlt",
        imgTitle: "imgTitle",
        path: "path"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsThreesixty_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsThreesixty = __decorate([ProxyCmp({
    inputs: ['caption', 'dataAmount', 'imgAlt', 'imgTitle', 'path']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsThreesixty);
  return SewWsThreesixty;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsTileCollection = /*#__PURE__*/(() => {
  let SewWsTileCollection = class SewWsTileCollection {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsTileCollection_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsTileCollection)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsTileCollection,
      selectors: [["sew-ws-tile-collection"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsTileCollection_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsTileCollection = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsTileCollection);
  return SewWsTileCollection;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsTileGallery = /*#__PURE__*/(() => {
  let SewWsTileGallery = class SewWsTileGallery {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsTileGallery_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsTileGallery)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsTileGallery,
      selectors: [["sew-ws-tile-gallery"]],
      inputs: {
        headline: "headline",
        noGrid: "noGrid",
        noMargin: "noMargin",
        text: "text",
        theme: "theme"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsTileGallery_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsTileGallery = __decorate([ProxyCmp({
    inputs: ['headline', 'noGrid', 'noMargin', 'text', 'theme']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsTileGallery);
  return SewWsTileGallery;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsTileGalleryItem = /*#__PURE__*/(() => {
  let SewWsTileGalleryItem = class SewWsTileGalleryItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['tileGalleryItemClicked']);
    }
    static ɵfac = function SewWsTileGalleryItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsTileGalleryItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsTileGalleryItem,
      selectors: [["sew-ws-tile-gallery-item"]],
      inputs: {
        headline: "headline",
        icon: "icon",
        size: "size"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsTileGalleryItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsTileGalleryItem = __decorate([ProxyCmp({
    inputs: ['headline', 'icon', 'size'],
    methods: ['openItem']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsTileGalleryItem);
  return SewWsTileGalleryItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsTimeline = /*#__PURE__*/(() => {
  let SewWsTimeline = class SewWsTimeline {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsTimeline_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsTimeline)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsTimeline,
      selectors: [["sew-ws-timeline"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsTimeline_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsTimeline = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsTimeline);
  return SewWsTimeline;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsTipButton = /*#__PURE__*/(() => {
  let SewWsTipButton = class SewWsTipButton {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['clickedButton']);
    }
    static ɵfac = function SewWsTipButton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsTipButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsTipButton,
      selectors: [["sew-ws-tip-button"]],
      inputs: {
        expanded: "expanded",
        initialAnimation: "initialAnimation",
        initialAnimationDuration: "initialAnimationDuration",
        tipLabel: "tipLabel"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsTipButton_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsTipButton = __decorate([ProxyCmp({
    inputs: ['expanded', 'initialAnimation', 'initialAnimationDuration', 'tipLabel']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsTipButton);
  return SewWsTipButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsTooltip = /*#__PURE__*/(() => {
  let SewWsTooltip = class SewWsTooltip {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['tooltipToggle']);
    }
    static ɵfac = function SewWsTooltip_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsTooltip)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsTooltip,
      selectors: [["sew-ws-tooltip"]],
      inputs: {
        delay: "delay"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsTooltip_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsTooltip = __decorate([ProxyCmp({
    inputs: ['delay']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsTooltip);
  return SewWsTooltip;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsWatchlist = /*#__PURE__*/(() => {
  let SewWsWatchlist = class SewWsWatchlist {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['watchlistChangeReverse']);
    }
    static ɵfac = function SewWsWatchlist_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsWatchlist)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsWatchlist,
      selectors: [["sew-ws-watchlist"]],
      inputs: {
        headline: "headline",
        items: "items"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsWatchlist_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsWatchlist = __decorate([ProxyCmp({
    inputs: ['headline', 'items']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsWatchlist);
  return SewWsWatchlist;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsWhatsappService = /*#__PURE__*/(() => {
  let SewWsWhatsappService = class SewWsWhatsappService {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsWhatsappService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsWhatsappService)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsWhatsappService,
      selectors: [["sew-ws-whatsapp-service"]],
      inputs: {
        headline: "headline",
        items: "items"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsWhatsappService_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsWhatsappService = __decorate([ProxyCmp({
    inputs: ['headline', 'items']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsWhatsappService);
  return SewWsWhatsappService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsWizard = /*#__PURE__*/(() => {
  let SewWsWizard = class SewWsWizard {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsWizard_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsWizard)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsWizard,
      selectors: [["sew-ws-wizard"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsWizard_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsWizard = __decorate([ProxyCmp({}), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsWizard);
  return SewWsWizard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SewWsWizardItem = /*#__PURE__*/(() => {
  let SewWsWizardItem = class SewWsWizardItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    static ɵfac = function SewWsWizardItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewWsWizardItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SewWsWizardItem,
      selectors: [["sew-ws-wizard-item"]],
      inputs: {
        active: "active",
        completed: "completed",
        minizize: "minizize",
        stepIndex: "stepIndex"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function SewWsWizardItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  SewWsWizardItem = __decorate([ProxyCmp({
    inputs: ['active', 'completed', 'minizize', 'stepIndex']
  }), __metadata("design:paramtypes", [ChangeDetectorRef, ElementRef, NgZone])], SewWsWizardItem);
  return SewWsWizardItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DIRECTIVES = [SewAccordion, SewAccordionItem, SewAdTeaser, SewApplication, SewApplicationContent, SewButton, SewCapacityIndicator, SewCards, SewCardsItem, SewCheckbox, SewCheckboxGroup, SewCmsSvgList, SewCombobox, SewDeliveryStatus, SewDialog, SewDropdown, SewFileUpload, SewForm, SewFormRow, SewFormRowItem, SewFourColumnGrid, SewHeader, SewHeadline, SewIcon, SewImageViewer, SewInput, SewLink, SewLoader, SewLoaderMini, SewMap, SewMarkdown, SewMasterDetail, SewMasterDetailPanel, SewMenu, SewMenu2, SewMenuItem, SewMenuItem2, SewMultiselect, SewNotification, SewNotificationStack, SewObserve, SewPicture, SewRadio, SewRadioGroup, SewRangeSlider, SewRichtext, SewRichtextEditor, SewSearchField, SewSearchFieldGoogleApi, SewSidePanel, SewSidePanelItem, SewSingleCombobox, SewSkeleton, SewSlider, SewSplashScreen, SewSwitch, SewSwitchGroup, SewTabBar, SewTabBarItem, SewTable, SewTableHeader, SewTableHeaderFilter, SewTableHeaderSort, SewTableInput, SewTag, SewTitleEditable, SewToolbar, SewTooltip, SewTypography, SewVerticalNavigation, SewVerticalNavigationItem, SewVideo, SewWizard, SewWizardItem, SewWsAccordionHorizontal, SewWsAccordionHorizontalItem, SewWsAnimatedNumbers, SewWsAnimatedNumbersItem, SewWsBarChart, SewWsBarChartChart, SewWsBarChartNumbers, SewWsBarChartNumbersItem, SewWsBasket, SewWsBreadcrumb, SewWsBulletlist, SewWsButton, SewWsCareer, SewWsCareerSlide, SewWsCircleTeaser, SewWsCircleTeaserItem, SewWsCircleTeaser2, SewWsCircleTeaser2Item, SewWsCompareSlider, SewWsCompass, SewWsCompassMenu, SewWsConnect, SewWsContactTeaser, SewWsContactTeaserLinklistSocial, SewWsContactTeaserSimple, SewWsContactWorldwide, SewWsContactWorldwideAddressList, SewWsContactWorldwideDirections, SewWsContactWorldwideFilter, SewWsContactWorldwideTag, SewWsContentToggle, SewWsContentWrapper, SewWsCta, SewWsCurtainSlideshow, SewWsCurtainSlideshowItem, SewWsCurtainSlideshow2, SewWsCurtainSlideshow2Item, SewWsDownloadList, SewWsDownloadListItem, SewWsDownloads, SewWsDummy, SewWsDynamicImageSlider, SewWsDynamicImageSliderItem, SewWsDynamicScrollSlider, SewWsDynamicScrollSliderItem, SewWsEmployeeQuotes, SewWsEmployeeQuotesItem, SewWsEvents, SewWsEventsApi, SewWsEventsItem, SewWsEventsStartpage, SewWsEventsTeaser, SewWsFactsAndFigures, SewWsFactsAndFiguresItem, SewWsFlipCard, SewWsFlipCardSlider, SewWsFloatingButtons, SewWsFloatingButtonsApi, SewWsFloatingNavigation, SewWsFloatingTiles, SewWsFloatingTilesItem, SewWsFloor, SewWsFlyout, SewWsFooter, SewWsFooterApi, SewWsFooterDummy, SewWsFooterLink, SewWsFooterLinklist, SewWsFooterLinklistLegal, SewWsFooterLinklistSocial, SewWsFooterPhone, SewWsFooterTeaser, SewWsFullscreenQuote, SewWsFullscreenTeaser, SewWsFullscreenTeaserItem, SewWsFullscreenTeaser3, SewWsFullscreenTeaser3Item, SewWsGrid, SewWsGrid16, SewWsGridLimited, SewWsGsap, SewWsHeader, SewWsHeaderDevmode, SewWsHeroSlideInTeaser, SewWsHeroSlideInTeaserItem, SewWsHeroimageWithTeaseroverlap, SewWsHttperror, SewWsImageMap, SewWsImageMapInfoLayer, SewWsImageSlider, SewWsImageSliderItem, SewWsImageStatsDisplay, SewWsImageStatsDisplayItem, SewWsImageText, SewWsImageTextFloat, SewWsImageTextFullscreen, SewWsImageTextFullscreenItem, SewWsImageTextRotation, SewWsImageTextRotationItem, SewWsImageTextTriple, SewWsImageZoom, SewWsIndustries, SewWsInfoTiles, SewWsInfoTilesItem, SewWsIntro, SewWsLexfinder, SewWsLightbox, SewWsLink, SewWsLinkPanels, SewWsLinkPanels2, SewWsLinkPanels2Item, SewWsLinkPanelsItem, SewWsLinklist, SewWsLinklistMenu, SewWsLocaleSwitch, SewWsLocations, SewWsLocationsMap, SewWsLocationsTeaser, SewWsLogin, SewWsLoginForm, SewWsMenuLink, SewWsMultiButton, SewWsNavigation, SewWsNews, SewWsNewsApi, SewWsNewsContent, SewWsNewsFeed, SewWsNewsFeedItem, SewWsNotification, SewWsNotifications, SewWsOutro, SewWsPageContentTeaser, SewWsPageContentTeaserSimple, SewWsParagraph, SewWsPasswordForgottenForm, SewWsPictureWrapper, SewWsPieChart, SewWsPieChartChart, SewWsPieChartNumbers, SewWsPieChartNumbersItem, SewWsPieChartTooltip, SewWsPodcast, SewWsPopularBlogs, SewWsPopularBlogsItem, SewWsPortfolio, SewWsPortfolioItem, SewWsPortfolio2, SewWsPortfolio2Item, SewWsPortraitTeaser2, SewWsPortraitTeaser2Item, SewWsPressCenter, SewWsPressCenterContactTeaser, SewWsPressCenterTeaser, SewWsProductInfo, SewWsProductLinks, SewWsProductLinksItem, SewWsProductSelection, SewWsProductSelectionItem, SewWsProductSelectionItemSlide, SewWsProductfinder, SewWsProtectedLink, SewWsQuote, SewWsQuote2, SewWsReader, SewWsReferences, SewWsReferencesItem, SewWsRegistrationExtendedForm, SewWsRegistrationForm, SewWsReportPreRegistration, SewWsRichtext, SewWsRoadmap, SewWsRoadmapItem, SewWsScrolldownIndicator, SewWsSearch, SewWsSearchLink, SewWsSearchResult, SewWsSearchSuggestions, SewWsSearchresultList, SewWsSearchresultListItem, SewWsSectors, SewWsSectorsItem, SewWsServices, SewWsServicesContact, SewWsServicesItem, SewWsServicesProduct, SewWsServicesReferences, SewWsShowMore, SewWsSlidetoggle, SewWsSlidetoggleContainer, SewWsSocialMedia, SewWsSocialMediaOutro, SewWsSocialMediaOutroItem, SewWsStage, SewWsStageHeadlineRotation, SewWsStageItem, SewWsStageParallax, SewWsStageTypeMotion, SewWsSubcategoryItemsView, SewWsTabNavigation, SewWsTabNavigationItem, SewWsTable, SewWsTabs, SewWsTabsItem, SewWsTabsTable, SewWsTeaser, SewWsTeaserAccessoireItem, SewWsTeaserItem, SewWsTeaserPortraitItem, SewWsTeaserProductItem, SewWsTextSplit, SewWsTextanimation, SewWsThreesixty, SewWsTileCollection, SewWsTileGallery, SewWsTileGalleryItem, SewWsTimeline, SewWsTipButton, SewWsTooltip, SewWsWatchlist, SewWsWhatsappService, SewWsWizard, SewWsWizardItem];
let SewUiComponentsModule = /*#__PURE__*/(() => {
  class SewUiComponentsModule {
    static ɵfac = function SewUiComponentsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SewUiComponentsModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SewUiComponentsModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: APP_INITIALIZER,
        useFactory: () => defineCustomElements,
        multi: true
      }]
    });
  }
  return SewUiComponentsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of component-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DIRECTIVES, SewAccordion, SewAccordionItem, SewAdTeaser, SewApplication, SewApplicationContent, SewButton, SewCapacityIndicator, SewCards, SewCardsItem, SewCheckbox, SewCheckboxGroup, SewCmsSvgList, SewCombobox, SewDeliveryStatus, SewDialog, SewDropdown, SewFileUpload, SewForm, SewFormRow, SewFormRowItem, SewFourColumnGrid, SewHeader, SewHeadline, SewIcon, SewImageViewer, SewInput, SewLink, SewLoader, SewLoaderMini, SewMap, SewMarkdown, SewMasterDetail, SewMasterDetailPanel, SewMenu, SewMenu2, SewMenuItem, SewMenuItem2, SewMultiselect, SewNotification, SewNotificationStack, SewObserve, SewPicture, SewRadio, SewRadioGroup, SewRangeSlider, SewRichtext, SewRichtextEditor, SewSearchField, SewSearchFieldGoogleApi, SewSidePanel, SewSidePanelItem, SewSingleCombobox, SewSkeleton, SewSlider, SewSplashScreen, SewSwitch, SewSwitchGroup, SewTabBar, SewTabBarItem, SewTable, SewTableHeader, SewTableHeaderFilter, SewTableHeaderSort, SewTableInput, SewTag, SewTitleEditable, SewToolbar, SewTooltip, SewTypography, SewUiComponentsModule, SewVerticalNavigation, SewVerticalNavigationItem, SewVideo, SewWizard, SewWizardItem, SewWsAccordionHorizontal, SewWsAccordionHorizontalItem, SewWsAnimatedNumbers, SewWsAnimatedNumbersItem, SewWsBarChart, SewWsBarChartChart, SewWsBarChartNumbers, SewWsBarChartNumbersItem, SewWsBasket, SewWsBreadcrumb, SewWsBulletlist, SewWsButton, SewWsCareer, SewWsCareerSlide, SewWsCircleTeaser, SewWsCircleTeaser2, SewWsCircleTeaser2Item, SewWsCircleTeaserItem, SewWsCompareSlider, SewWsCompass, SewWsCompassMenu, SewWsConnect, SewWsContactTeaser, SewWsContactTeaserLinklistSocial, SewWsContactTeaserSimple, SewWsContactWorldwide, SewWsContactWorldwideAddressList, SewWsContactWorldwideDirections, SewWsContactWorldwideFilter, SewWsContactWorldwideTag, SewWsContentToggle, SewWsContentWrapper, SewWsCta, SewWsCurtainSlideshow, SewWsCurtainSlideshow2, SewWsCurtainSlideshow2Item, SewWsCurtainSlideshowItem, SewWsDownloadList, SewWsDownloadListItem, SewWsDownloads, SewWsDummy, SewWsDynamicImageSlider, SewWsDynamicImageSliderItem, SewWsDynamicScrollSlider, SewWsDynamicScrollSliderItem, SewWsEmployeeQuotes, SewWsEmployeeQuotesItem, SewWsEvents, SewWsEventsApi, SewWsEventsItem, SewWsEventsStartpage, SewWsEventsTeaser, SewWsFactsAndFigures, SewWsFactsAndFiguresItem, SewWsFlipCard, SewWsFlipCardSlider, SewWsFloatingButtons, SewWsFloatingButtonsApi, SewWsFloatingNavigation, SewWsFloatingTiles, SewWsFloatingTilesItem, SewWsFloor, SewWsFlyout, SewWsFooter, SewWsFooterApi, SewWsFooterDummy, SewWsFooterLink, SewWsFooterLinklist, SewWsFooterLinklistLegal, SewWsFooterLinklistSocial, SewWsFooterPhone, SewWsFooterTeaser, SewWsFullscreenQuote, SewWsFullscreenTeaser, SewWsFullscreenTeaser3, SewWsFullscreenTeaser3Item, SewWsFullscreenTeaserItem, SewWsGrid, SewWsGrid16, SewWsGridLimited, SewWsGsap, SewWsHeader, SewWsHeaderDevmode, SewWsHeroSlideInTeaser, SewWsHeroSlideInTeaserItem, SewWsHeroimageWithTeaseroverlap, SewWsHttperror, SewWsImageMap, SewWsImageMapInfoLayer, SewWsImageSlider, SewWsImageSliderItem, SewWsImageStatsDisplay, SewWsImageStatsDisplayItem, SewWsImageText, SewWsImageTextFloat, SewWsImageTextFullscreen, SewWsImageTextFullscreenItem, SewWsImageTextRotation, SewWsImageTextRotationItem, SewWsImageTextTriple, SewWsImageZoom, SewWsIndustries, SewWsInfoTiles, SewWsInfoTilesItem, SewWsIntro, SewWsLexfinder, SewWsLightbox, SewWsLink, SewWsLinkPanels, SewWsLinkPanels2, SewWsLinkPanels2Item, SewWsLinkPanelsItem, SewWsLinklist, SewWsLinklistMenu, SewWsLocaleSwitch, SewWsLocations, SewWsLocationsMap, SewWsLocationsTeaser, SewWsLogin, SewWsLoginForm, SewWsMenuLink, SewWsMultiButton, SewWsNavigation, SewWsNews, SewWsNewsApi, SewWsNewsContent, SewWsNewsFeed, SewWsNewsFeedItem, SewWsNotification, SewWsNotifications, SewWsOutro, SewWsPageContentTeaser, SewWsPageContentTeaserSimple, SewWsParagraph, SewWsPasswordForgottenForm, SewWsPictureWrapper, SewWsPieChart, SewWsPieChartChart, SewWsPieChartNumbers, SewWsPieChartNumbersItem, SewWsPieChartTooltip, SewWsPodcast, SewWsPopularBlogs, SewWsPopularBlogsItem, SewWsPortfolio, SewWsPortfolio2, SewWsPortfolio2Item, SewWsPortfolioItem, SewWsPortraitTeaser2, SewWsPortraitTeaser2Item, SewWsPressCenter, SewWsPressCenterContactTeaser, SewWsPressCenterTeaser, SewWsProductInfo, SewWsProductLinks, SewWsProductLinksItem, SewWsProductSelection, SewWsProductSelectionItem, SewWsProductSelectionItemSlide, SewWsProductfinder, SewWsProtectedLink, SewWsQuote, SewWsQuote2, SewWsReader, SewWsReferences, SewWsReferencesItem, SewWsRegistrationExtendedForm, SewWsRegistrationForm, SewWsReportPreRegistration, SewWsRichtext, SewWsRoadmap, SewWsRoadmapItem, SewWsScrolldownIndicator, SewWsSearch, SewWsSearchLink, SewWsSearchResult, SewWsSearchSuggestions, SewWsSearchresultList, SewWsSearchresultListItem, SewWsSectors, SewWsSectorsItem, SewWsServices, SewWsServicesContact, SewWsServicesItem, SewWsServicesProduct, SewWsServicesReferences, SewWsShowMore, SewWsSlidetoggle, SewWsSlidetoggleContainer, SewWsSocialMedia, SewWsSocialMediaOutro, SewWsSocialMediaOutroItem, SewWsStage, SewWsStageHeadlineRotation, SewWsStageItem, SewWsStageParallax, SewWsStageTypeMotion, SewWsSubcategoryItemsView, SewWsTabNavigation, SewWsTabNavigationItem, SewWsTable, SewWsTabs, SewWsTabsItem, SewWsTabsTable, SewWsTeaser, SewWsTeaserAccessoireItem, SewWsTeaserItem, SewWsTeaserPortraitItem, SewWsTeaserProductItem, SewWsTextSplit, SewWsTextanimation, SewWsThreesixty, SewWsTileCollection, SewWsTileGallery, SewWsTileGalleryItem, SewWsTimeline, SewWsTipButton, SewWsTooltip, SewWsWatchlist, SewWsWhatsappService, SewWsWizard, SewWsWizardItem };
